var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.445,
    height: 18.728,
    viewBox: "0 0 14.445 18.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-43{fill:#ff7b00}.prefix__cls-107{fill:#ffb815}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__icons8-fire",
    transform: "translate(-8 -3.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6172",
    fill: "#ff5100",
    d: "M12.261 7.873a6.817 6.817 0 0 0 2.119-4.767c4 1.479 2.731 6.442 3.541 6.442.531 0 .98-.731.94-2.873 5.111 4.443 1.42 8.293 2.81 8.293.456 0 .774-.838.774-.838 0 4.875-3.306 7.7-7.045 7.7-3.788 0-7.4-2.209-7.4-7.611 0 0 .809 1.428 1.489 1.087.911-.452-1.543-3.714 2.772-7.433z",
    "data-name": "Path 6172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6173",
    fill: "#ff5200",
    d: "M12.274 7.947a6.855 6.855 0 0 0 2.133-4.77c3.972 1.491 2.7 6.421 3.524 6.428.535 0 .992-.727.955-2.859 5.073 4.421 1.393 8.272 2.784 8.28.457 0 .782-.832.782-.832-.006 4.842-3.3 7.665-7.036 7.67-3.768 0-7.376-2.2-7.387-7.573 0 0 .814 1.417 1.494 1.073.909-.464-1.53-3.72 2.751-7.417z",
    "data-name": "Path 6173",
    transform: "translate(-.015 -.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6174",
    fill: "#ff5300",
    d: "M12.286 8.019a6.871 6.871 0 0 0 2.147-4.772c3.948 1.5 2.668 6.4 3.505 6.414.54.008 1-.723.97-2.844 5.035 4.4 1.366 8.251 2.758 8.268.458.006.79-.824.79-.824-.013 4.809-3.294 7.63-7.027 7.636-3.749 0-7.352-2.187-7.374-7.535 0 0 .819 1.405 1.5 1.058.907-.466-1.507-3.714 2.731-7.401z",
    "data-name": "Path 6174",
    transform: "translate(-.029 -.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6175",
    fill: "#ff5400",
    d: "M12.3 8.091a6.9 6.9 0 0 0 2.161-4.775c3.924 1.516 2.636 6.382 3.487 6.4.544.012 1.017-.719.985-2.83 5 4.376 1.339 8.229 2.732 8.255.459.01.8-.817.8-.817-.019 4.776-3.288 7.6-7.018 7.6s-7.329-2.177-7.36-7.5c0 0 .823 1.394 1.5 1.043C10.492 15 8.1 11.761 12.3 8.091z",
    "data-name": "Path 6175",
    transform: "translate(-.043 -.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6176",
    fill: "#f50",
    d: "M12.312 8.165a6.925 6.925 0 0 0 2.175-4.778c3.9 1.528 2.6 6.362 3.469 6.386.548.015 1.029-.715 1-2.815 4.958 4.354 1.312 8.209 2.705 8.243.46.013.8-.81.8-.81-.026 4.742-3.282 7.563-7.009 7.567-3.71 0-7.3-2.166-7.347-7.46 0 0 .828 1.383 1.506 1.028.91-.473-1.461-3.708 2.701-7.361z",
    "data-name": "Path 6176",
    transform: "translate(-.057 -.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6177",
    fill: "#ff5600",
    d: "M12.325 8.236a6.951 6.951 0 0 0 2.189-4.78C18.39 5 17.086 9.8 17.965 9.828c.552.019 1.042-.711 1.015-2.8 4.92 4.332 1.285 8.185 2.679 8.23.462.015.812-.8.812-.8-.032 4.71-3.277 7.528-7 7.533-3.691 0-7.281-2.155-7.334-7.421 0 0 .833 1.371 1.51 1.014.904-.484-1.447-3.711 2.678-7.348z",
    "data-name": "Path 6177",
    transform: "translate(-.071 -.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6178",
    fill: "#ff5700",
    d: "M12.338 8.309a6.977 6.977 0 0 0 2.2-4.783c3.853 1.553 2.541 6.322 3.433 6.358.557.023 1.054-.707 1.03-2.787 4.882 4.31 1.258 8.163 2.653 8.218.463.018.82-.8.82-.8-.038 4.676-3.271 7.494-6.991 7.5-3.672 0-7.257-2.145-7.321-7.383 0 0 .838 1.36 1.514 1 .906-.48-1.424-3.703 2.662-7.323z",
    "data-name": "Path 6178",
    transform: "translate(-.086 -.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6179",
    fill: "#ff5800",
    d: "M12.351 8.381A7 7 0 0 0 14.568 3.6c3.829 1.565 2.51 6.3 3.415 6.344.561.026 1.067-.7 1.045-2.773 4.843 4.288 1.231 8.141 2.627 8.205.464.021.827-.788.827-.788-.044 4.643-3.265 7.46-6.981 7.465-3.653 0-7.234-2.134-7.308-7.346 0 0 .843 1.349 1.518.984.901-.491-1.411-3.707 2.64-7.31z",
    "data-name": "Path 6179",
    transform: "translate(-.1 -.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6180",
    fill: "#ff5900",
    d: "M12.364 8.454A7.032 7.032 0 0 0 14.6 3.666c3.8 1.578 2.478 6.281 3.4 6.33.565.03 1.079-.7 1.06-2.758 4.805 4.266 1.2 8.12 2.6 8.193.465.025.835-.781.835-.781-.051 4.61-3.259 7.426-6.972 7.431-3.633 0-7.21-2.123-7.3-7.308 0 0 .847 1.338 1.522.969.898-.49-1.392-3.702 2.619-7.288z",
    "data-name": "Path 6180",
    transform: "translate(-.115 -.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6181",
    fill: "#ff5a00",
    d: "M12.376 8.526a7.054 7.054 0 0 0 2.246-4.791C18.4 5.325 17.068 10 18 10.051c.569.034 1.091-.695 1.075-2.744 4.767 4.244 1.176 8.1 2.574 8.18.467.027.842-.774.842-.774-.057 4.577-3.253 7.392-6.963 7.4-3.614 0-7.186-2.113-7.282-7.27 0 0 .853 1.327 1.526.954.899-.497-1.372-3.702 2.604-7.271z",
    "data-name": "Path 6181",
    transform: "translate(-.128 -.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6182",
    fill: "#ff5b00",
    d: "M12.389 8.6a7.081 7.081 0 0 0 2.26-4.793c3.757 1.6 2.415 6.24 3.36 6.3.573.037 1.1-.69 1.091-2.729 4.729 4.222 1.149 8.077 2.548 8.168.468.03.85-.767.85-.767-.064 4.544-3.247 7.357-6.953 7.362-3.595 0-7.162-2.1-7.269-7.232 0 0 .858 1.315 1.53.939.894-.497-1.353-3.698 2.583-7.248z",
    "data-name": "Path 6182",
    transform: "translate(-.143 -.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6183",
    fill: "#ff5c00",
    d: "M12.4 8.671a7.106 7.106 0 0 0 2.274-4.8c3.734 1.615 2.383 6.22 3.343 6.288.578.041 1.116-.687 1.106-2.715 4.691 4.2 1.122 8.055 2.522 8.156.469.034.858-.76.858-.76-.07 4.511-3.241 7.323-6.944 7.328-3.576 0-7.139-2.091-7.256-7.194 0 0 .862 1.3 1.535.924.894-.498-1.338-3.693 2.562-7.227z",
    "data-name": "Path 6183",
    transform: "translate(-.157 -.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6184",
    fill: "#ff5d00",
    d: "M12.416 8.744a7.129 7.129 0 0 0 2.288-4.8c3.71 1.627 2.352 6.2 3.324 6.274.582.044 1.128-.682 1.12-2.7 4.652 4.178 1.095 8.034 2.5 8.143.47.037.865-.753.865-.753-.076 4.478-3.235 7.289-6.935 7.294-3.556 0-7.115-2.081-7.243-7.156 0 0 .867 1.293 1.538.91.89-.506-1.32-3.696 2.543-7.212z",
    "data-name": "Path 6184",
    transform: "translate(-.172 -.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6185",
    fill: "#ff5e00",
    d: "M12.429 8.816a7.154 7.154 0 0 0 2.3-4.8c3.686 1.64 2.32 6.179 3.307 6.26.586.048 1.141-.678 1.135-2.686 4.614 4.156 1.068 8.012 2.47 8.131.471.04.872-.745.872-.745-.083 4.444-3.229 7.255-6.926 7.26-3.538 0-7.091-2.07-7.23-7.118 0 0 .872 1.281 1.543.9.893-.518-1.3-3.704 2.529-7.202z",
    "data-name": "Path 6185",
    transform: "translate(-.186 -.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6186",
    fill: "#ff5f00",
    d: "M12.441 8.889a7.18 7.18 0 0 0 2.317-4.8c3.662 1.653 2.288 6.158 3.288 6.246.59.052 1.153-.674 1.151-2.672 4.576 4.134 1.041 7.991 2.443 8.118.473.043.88-.738.88-.738-.089 4.407-3.22 7.217-6.92 7.221-3.518 0-7.068-2.059-7.217-7.081 0 0 .877 1.27 1.547.88.892-.514-1.277-3.694 2.511-7.174z",
    "data-name": "Path 6186",
    transform: "translate(-.2 -.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6187",
    fill: "#ff6000",
    d: "M12.454 8.961a7.2 7.2 0 0 0 2.33-4.806c3.638 1.665 2.257 6.138 3.27 6.232.595.055 1.166-.67 1.166-2.657 4.538 4.112 1.014 7.969 2.417 8.106.474.046.887-.731.887-.731-.1 4.378-3.217 7.187-6.908 7.191-3.5 0-7.044-2.048-7.2-7.043 0 0 .882 1.259 1.551.865.885-.518-1.267-3.695 2.487-7.157z",
    "data-name": "Path 6187",
    transform: "translate(-.214 -.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6188",
    fill: "#ff6100",
    d: "M12.467 9.033a7.225 7.225 0 0 0 2.344-4.809c3.614 1.677 2.225 6.118 3.252 6.217.6.058 1.178-.666 1.181-2.643 4.5 4.089.987 7.948 2.391 8.093.475.049.9-.724.9-.724-.1 4.345-3.212 7.153-6.9 7.157-3.48 0-7.02-2.038-7.191-7 0 0 .886 1.248 1.555.85.884-.526-1.247-3.697 2.468-7.141z",
    "data-name": "Path 6188",
    transform: "translate(-.229 -.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6189",
    fill: "#ff6200",
    d: "M12.479 9.107A7.249 7.249 0 0 0 14.838 4.3c3.591 1.69 2.193 6.1 3.234 6.2.6.062 1.19-.662 1.2-2.629 4.462 4.067.96 7.927 2.365 8.081.476.052.9-.716.9-.716a6.916 6.916 0 0 1-6.889 7.123c-3.461 0-7-2.027-7.178-6.967 0 0 .891 1.237 1.559.836.883-.528-1.229-3.697 2.45-7.121z",
    "data-name": "Path 6189",
    transform: "translate(-.243 -.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6190",
    fill: "#ff6300",
    d: "M12.493 9.179a7.273 7.273 0 0 0 2.373-4.815c3.567 1.7 2.162 6.076 3.216 6.189.607.065 1.2-.658 1.211-2.615 4.423 4.046.933 7.905 2.339 8.068.478.055.91-.709.91-.709a6.906 6.906 0 0 1-6.88 7.089c-3.441 0-6.973-2.017-7.165-6.929 0 0 .9 1.225 1.563.821.883-.531-1.21-3.693 2.433-7.099z",
    "data-name": "Path 6190",
    transform: "translate(-.257 -.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6191",
    fill: "#ff6400",
    d: "M12.506 9.251a7.3 7.3 0 0 0 2.387-4.817c3.543 1.715 2.13 6.056 3.2 6.175.612.068 1.215-.654 1.226-2.6 4.385 4.023.906 7.884 2.312 8.056.479.058.918-.7.918-.7a6.9 6.9 0 0 1-6.871 7.055c-3.422 0-6.949-2.005-7.152-6.891 0 0 .9 1.214 1.567.806.88-.535-1.193-3.697 2.413-7.084z",
    "data-name": "Path 6191",
    transform: "translate(-.272 -.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6192",
    fill: "#ff6500",
    d: "M12.518 9.323a7.317 7.317 0 0 0 2.4-4.82c3.519 1.727 2.1 6.035 3.179 6.161.616.072 1.227-.65 1.241-2.586 4.347 4 .879 7.863 2.286 8.044.48.062.925-.695.925-.695a6.885 6.885 0 0 1-6.861 7.02c-3.4 0-6.925-1.995-7.139-6.853 0 0 .905 1.2 1.571.792.88-.542-1.172-3.694 2.398-7.063z",
    "data-name": "Path 6192",
    transform: "translate(-.285 -.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6193",
    fill: "#f60",
    d: "M12.53 9.4a7.34 7.34 0 0 0 2.415-4.822c3.495 1.739 2.067 6.015 3.162 6.147.62.075 1.24-.646 1.256-2.572 4.309 3.979.851 7.841 2.26 8.031.482.065.933-.688.933-.688a6.874 6.874 0 0 1-6.856 6.983c-3.384 0-6.9-1.984-7.126-6.815 0 0 .91 1.19 1.575.777.882-.546-1.149-3.696 2.381-7.041z",
    "data-name": "Path 6193",
    transform: "translate(-.299 -.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6194",
    fill: "#ff6700",
    d: "M12.544 9.468a7.364 7.364 0 0 0 2.43-4.825c3.471 1.752 2.035 5.994 3.143 6.133.625.078 1.252-.642 1.271-2.557 4.27 3.957.824 7.82 2.234 8.019.482.068.94-.68.94-.68a6.863 6.863 0 0 1-6.843 6.952c-3.364 0-6.878-1.974-7.112-6.777 0 0 .915 1.179 1.579.762.876-.551-1.14-3.695 2.358-7.027z",
    "data-name": "Path 6194",
    transform: "translate(-.314 -.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6195",
    fill: "#ff6800",
    d: "M12.557 9.541A7.385 7.385 0 0 0 15 4.713c3.447 1.764 2 5.973 3.125 6.119.628.082 1.264-.638 1.286-2.543 4.232 3.935.8 7.8 2.207 8.006.484.071.948-.673.948-.673a6.853 6.853 0 0 1-6.834 6.918c-3.345 0-6.854-1.963-7.1-6.739 0 0 .92 1.168 1.584.747.876-.555-1.121-3.697 2.341-7.007z",
    "data-name": "Path 6195",
    transform: "translate(-.329 -.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6196",
    fill: "#ff6900",
    d: "M12.57 9.614a7.4 7.4 0 0 0 2.458-4.83c3.424 1.777 1.972 5.952 3.107 6.105.633.085 1.277-.634 1.3-2.528 4.194 3.913.77 7.778 2.181 7.994.485.074.955-.666.955-.666a6.843 6.843 0 0 1-6.825 6.884c-3.326 0-6.83-1.952-7.086-6.7 0 0 .924 1.156 1.588.732.874-.561-1.105-3.705 2.322-6.991z",
    "data-name": "Path 6196",
    transform: "translate(-.343 -.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6197",
    fill: "#ff6a00",
    d: "M12.583 9.686a7.431 7.431 0 0 0 2.472-4.833c3.4 1.789 1.94 5.931 3.089 6.091.637.089 1.289-.629 1.316-2.514 4.156 3.891.743 7.757 2.155 7.981.486.078.963-.659.963-.659a6.833 6.833 0 0 1-6.815 6.848 6.712 6.712 0 0 1-7.073-6.662s.929 1.145 1.592.717c.87-.562-1.09-3.698 2.301-6.969z",
    "data-name": "Path 6197",
    transform: "translate(-.358 -.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6198",
    fill: "#ff6b00",
    d: "M12.6 9.758a7.45 7.45 0 0 0 2.486-4.835c3.376 1.8 1.909 5.911 3.071 6.077.641.092 1.3-.625 1.331-2.5 4.118 3.869.716 7.735 2.129 7.968.488.08.97-.651.97-.651a6.823 6.823 0 0 1-6.806 6.815 6.7 6.7 0 0 1-7.06-6.626s.934 1.134 1.6.7c.86-.564-1.081-3.696 2.279-6.948z",
    "data-name": "Path 6198",
    transform: "translate(-.371 -.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6199",
    fill: "#ff6c00",
    d: "M12.609 9.831a7.472 7.472 0 0 0 2.5-4.838c3.352 1.814 1.877 5.89 3.053 6.063.646.095 1.314-.621 1.346-2.486 4.079 3.847.689 7.714 2.1 7.956.489.084.978-.645.978-.645a6.814 6.814 0 0 1-6.8 6.782 6.694 6.694 0 0 1-7.047-6.588s.939 1.122 1.6.688c.873-.571-1.05-3.7 2.27-6.932z",
    "data-name": "Path 6199",
    transform: "translate(-.386 -.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6200",
    fill: "#ff6d00",
    d: "M12.621 9.9a7.494 7.494 0 0 0 2.514-4.841c3.328 1.826 1.846 5.869 3.035 6.049.65.1 1.327-.617 1.361-2.471 4.041 3.825.662 7.693 2.076 7.943.49.087.985-.638.985-.638a6.8 6.8 0 0 1-6.788 6.746 6.685 6.685 0 0 1-7.034-6.55s.944 1.111 1.6.673c.872-.569-1.034-3.696 2.251-6.911z",
    "data-name": "Path 6200",
    transform: "translate(-.4 -1.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6201",
    fill: "#ff6e00",
    d: "M12.634 9.975a7.516 7.516 0 0 0 2.528-4.843c3.3 1.839 1.814 5.848 3.017 6.035.654.1 1.339-.613 1.376-2.457 4 3.8.635 7.672 2.05 7.931.491.09.993-.63.993-.63a6.794 6.794 0 0 1-6.779 6.712A6.676 6.676 0 0 1 8.8 16.211s.949 1.1 1.608.658c.863-.578-1.024-3.702 2.226-6.894z",
    "data-name": "Path 6201",
    transform: "translate(-.414 -1.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6202",
    fill: "#ff6f00",
    d: "M12.647 10.049A7.538 7.538 0 0 0 15.19 5.2c3.281 1.851 1.783 5.827 3 6.021.658.1 1.352-.609 1.391-2.442 3.965 3.78.608 7.651 2.024 7.919.493.093 1-.623 1-.623a6.785 6.785 0 0 1-6.77 6.678 6.668 6.668 0 0 1-7.008-6.474s.953 1.089 1.612.643c.861-.581-1.006-3.702 2.208-6.873z",
    "data-name": "Path 6202",
    transform: "translate(-.429 -1.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6203",
    fill: "#ff7000",
    d: "M12.66 10.121a7.555 7.555 0 0 0 2.557-4.849c3.256 1.863 1.751 5.806 2.981 6.007.663.108 1.364-.6 1.406-2.428 3.927 3.759.581 7.629 2 7.906.494.1 1.008-.616 1.008-.616a6.776 6.776 0 0 1-6.76 6.644 6.659 6.659 0 0 1-6.995-6.436s.958 1.078 1.616.628c.859-.587-.993-3.706 2.187-6.856z",
    "data-name": "Path 6203",
    transform: "translate(-.443 -1.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6204",
    fill: "#ff7100",
    d: "M12.672 10.193a7.576 7.576 0 0 0 2.571-4.851c3.233 1.876 1.719 5.785 2.962 5.992.667.111 1.376-.6 1.421-2.414 3.888 3.736.554 7.608 1.972 7.894.495.1 1.016-.609 1.016-.609a6.766 6.766 0 0 1-6.751 6.61 6.652 6.652 0 0 1-6.982-6.4s.963 1.066 1.62.614c.861-.589-.973-3.706 2.171-6.836z",
    "data-name": "Path 6204",
    transform: "translate(-.457 -1.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6205",
    fill: "#ff7200",
    d: "M12.685 10.265a7.6 7.6 0 0 0 2.585-4.854c3.209 1.888 1.688 5.764 2.944 5.978.671.115 1.389-.6 1.436-2.4 3.85 3.714.527 7.588 1.945 7.881.5.1 1.023-.6 1.023-.6a6.758 6.758 0 0 1-6.742 6.575 6.644 6.644 0 0 1-6.969-6.36s.968 1.055 1.625.6c.86-.596-.957-3.71 2.153-6.82z",
    "data-name": "Path 6205",
    transform: "translate(-.471 -1.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6206",
    fill: "#ff7300",
    d: "M12.7 10.338a7.619 7.619 0 0 0 2.6-4.856c3.185 1.9 1.656 5.743 2.926 5.964.675.117 1.4-.593 1.451-2.385 3.812 3.692.5 7.566 1.919 7.869.5.106 1.03-.594 1.03-.594a6.749 6.749 0 0 1-6.733 6.541 6.636 6.636 0 0 1-6.956-6.323s.973 1.043 1.628.584c.856-.599-.943-3.711 2.135-6.8z",
    "data-name": "Path 6206",
    transform: "translate(-.485 -1.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6207",
    fill: "#ff7400",
    d: "M12.712 10.411a7.636 7.636 0 0 0 2.613-4.859c3.161 1.913 1.625 5.722 2.908 5.95.679.121 1.413-.589 1.467-2.37 3.774 3.67.473 7.545 1.893 7.856.5.109 1.038-.587 1.038-.587a6.742 6.742 0 0 1-6.724 6.507 6.629 6.629 0 0 1-6.943-6.285s.977 1.032 1.633.569c.855-.603-.927-3.713 2.115-6.781z",
    "data-name": "Path 6207",
    transform: "translate(-.5 -1.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6208",
    fill: "#ff7500",
    d: "M12.725 10.483a7.66 7.66 0 0 0 2.628-4.862c3.137 1.926 1.593 5.7 2.89 5.937.684.124 1.426-.585 1.482-2.356 3.736 3.648.445 7.524 1.867 7.844.5.113 1.045-.58 1.045-.58a6.733 6.733 0 0 1-6.714 6.473 6.622 6.622 0 0 1-6.93-6.247s.982 1.021 1.637.555c.852-.609-.912-3.717 2.095-6.764z",
    "data-name": "Path 6208",
    transform: "translate(-.514 -1.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6209",
    fill: "#ff7600",
    d: "M12.738 10.556a7.677 7.677 0 0 0 2.642-4.864c3.113 1.938 1.561 5.68 2.872 5.922.688.127 1.438-.581 1.5-2.342 3.7 3.626.418 7.5 1.841 7.831.5.116 1.053-.573 1.053-.573a6.724 6.724 0 0 1-6.7 6.439A6.615 6.615 0 0 1 9.02 16.76s.987 1.01 1.641.54c.851-.612-.896-3.718 2.077-6.744z",
    "data-name": "Path 6209",
    transform: "translate(-.529 -1.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6210",
    fill: "#f70",
    d: "M12.75 10.628c1.641-1.679 2.412-2.883 2.656-4.867 3.09 1.951 1.53 5.659 2.854 5.908.692.13 1.45-.576 1.511-2.328 3.659 3.6.391 7.482 1.814 7.819.5.119 1.061-.565 1.061-.565a6.717 6.717 0 0 1-6.7 6.4 6.608 6.608 0 0 1-6.9-6.171s.992 1 1.645.525c.851-.612-.879-3.716 2.059-6.721z",
    "data-name": "Path 6210",
    transform: "translate(-.543 -1.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6211",
    fill: "#ff7800",
    d: "M12.763 10.7c1.644-1.689 2.417-2.858 2.67-4.869 3.066 1.963 1.5 5.638 2.836 5.894.7.133 1.463-.573 1.527-2.313 3.621 3.582.365 7.461 1.788 7.807.5.122 1.068-.558 1.068-.558a6.709 6.709 0 0 1-6.687 6.37A6.6 6.6 0 0 1 9.074 16.9s1 .988 1.649.51c.849-.623-.864-3.726 2.04-6.71z",
    "data-name": "Path 6211",
    transform: "translate(-.557 -1.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6212",
    fill: "#ff7900",
    d: "M12.775 10.773C14.422 9.074 15.2 7.94 15.459 5.9c3.042 1.975 1.467 5.617 2.818 5.88.7.137 1.475-.568 1.542-2.3 3.583 3.56.337 7.44 1.762 7.794.5.125 1.076-.551 1.076-.551a6.7 6.7 0 0 1-6.678 6.336A6.6 6.6 0 0 1 9.1 16.967s1 .976 1.653.5c.847-.63-.847-3.732 2.022-6.694z",
    "data-name": "Path 6212",
    transform: "translate(-.571 -1.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6213",
    fill: "#ff7a00",
    d: "M12.789 10.846c1.649-1.71 2.426-2.809 2.7-4.875 3.018 1.988 1.435 5.6 2.8 5.866.7.14 1.488-.564 1.557-2.284 3.544 3.538.31 7.419 1.736 7.782.506.129 1.083-.544 1.083-.544a6.694 6.694 0 0 1-6.668 6.3 6.588 6.588 0 0 1-6.867-6.055s1.006.965 1.657.481c.845-.631-.834-3.731 2.002-6.671z",
    "data-name": "Path 6213",
    transform: "translate(-.586 -1.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6214",
    d: "M12.8 10.918c1.651-1.72 2.431-2.785 2.712-4.878 2.994 2 1.4 5.574 2.782 5.852.709.143 1.5-.56 1.572-2.27 3.506 3.515.283 7.4 1.71 7.769.508.132 1.091-.536 1.091-.536a6.687 6.687 0 0 1-6.659 6.268A6.582 6.582 0 0 1 9.157 17.1s1.011.953 1.661.466c.844-.63-.818-3.729 1.982-6.648z",
    className: "prefix__cls-43",
    "data-name": "Path 6214",
    transform: "translate(-.6 -1.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6215",
    d: "M12.815 10.991c1.653-1.731 2.435-2.76 2.726-4.88 2.97 2.013 1.372 5.553 2.763 5.838.714.146 1.512-.556 1.587-2.256 3.468 3.494.256 7.377 1.683 7.757.508.135 1.1-.529 1.1-.529a6.68 6.68 0 0 1-6.649 6.234 6.576 6.576 0 0 1-6.838-5.981s1.016.942 1.666.451c.839-.639-.807-3.737 1.962-6.634z",
    className: "prefix__cls-43",
    "data-name": "Path 6215",
    transform: "translate(-.614 -1.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6216",
    fill: "#ff7c00",
    d: "M12.828 11.063c1.656-1.741 2.44-2.735 2.741-4.883 2.946 2.025 1.341 5.532 2.745 5.824.718.149 1.525-.552 1.6-2.241 3.43 3.472.229 7.356 1.657 7.744.51.138 1.106-.522 1.106-.522a6.673 6.673 0 0 1-6.64 6.2 6.571 6.571 0 0 1-6.824-5.945s1.021.931 1.669.436c.841-.641-.789-3.737 1.946-6.613z",
    "data-name": "Path 6216",
    transform: "translate(-.629 -1.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6217",
    fill: "#ff7d00",
    d: "M12.84 11.135c1.66-1.751 2.444-2.711 2.754-4.885 2.923 2.037 1.309 5.511 2.727 5.81.722.152 1.537-.548 1.617-2.227 3.392 3.45.2 7.335 1.631 7.732.511.142 1.113-.515 1.113-.515a6.667 6.667 0 0 1-6.631 6.165 6.565 6.565 0 0 1-6.812-5.906s1.026.92 1.674.421c.839-.646-.775-3.741 1.927-6.595z",
    "data-name": "Path 6217",
    transform: "translate(-.642 -1.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6218",
    fill: "#ff7e00",
    d: "M12.853 11.207c1.66-1.762 2.449-2.686 2.769-4.888 2.9 2.05 1.277 5.49 2.709 5.8.727.156 1.549-.544 1.632-2.213 3.354 3.427.175 7.315 1.6 7.719.512.145 1.121-.508 1.121-.508a6.661 6.661 0 0 1-6.622 6.131 6.56 6.56 0 0 1-6.8-5.868s1.03.909 1.678.406c.842-.652-.755-3.747 1.913-6.579z",
    "data-name": "Path 6218",
    transform: "translate(-.657 -1.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6219",
    fill: "#ff7f00",
    d: "M12.866 11.281c1.663-1.773 2.453-2.662 2.783-4.891 2.875 2.062 1.246 5.468 2.691 5.782.731.158 1.562-.54 1.647-2.2 3.315 3.405.147 7.293 1.579 7.707.513.148 1.128-.5 1.128-.5a6.655 6.655 0 0 1-6.613 6.1A6.555 6.555 0 0 1 9.3 17.446s1.035.9 1.682.391c.831-.653-.75-3.747 1.884-6.556z",
    "data-name": "Path 6219",
    transform: "translate(-.671 -1.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6220",
    fill: "#ff8000",
    d: "M12.879 11.353c1.665-1.784 2.458-2.637 2.8-4.893 2.851 2.075 1.214 5.447 2.673 5.767.735.161 1.575-.536 1.662-2.184 3.277 3.383.12 7.273 1.552 7.694.515.152 1.136-.494 1.136-.494a6.649 6.649 0 0 1-6.6 6.063 6.551 6.551 0 0 1-6.773-5.792s1.041.886 1.686.377c.827-.657-.738-3.75 1.864-6.538z",
    "data-name": "Path 6220",
    transform: "translate(-.685 -1.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6221",
    fill: "#ff8100",
    d: "M12.892 11.425c1.666-1.795 2.462-2.613 2.812-4.9 2.827 2.087 1.183 5.426 2.655 5.754.74.165 1.587-.532 1.677-2.17 3.239 3.361.093 7.252 1.526 7.682.516.155 1.144-.486 1.144-.486a6.643 6.643 0 0 1-6.595 6.028 6.547 6.547 0 0 1-6.76-5.754s1.045.875 1.69.362c.832-.658-.717-3.751 1.851-6.516z",
    "data-name": "Path 6221",
    transform: "translate(-.7 -1.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6222",
    fill: "#ff8200",
    d: "M12.9 11.5c1.668-1.805 2.467-2.588 2.825-4.9 2.8 2.1 1.151 5.4 2.637 5.74.743.168 1.6-.528 1.692-2.155 3.2 3.339.066 7.231 1.5 7.669.517.158 1.151-.479 1.151-.479a6.638 6.638 0 0 1-6.586 5.994 6.542 6.542 0 0 1-6.747-5.716s1.05.864 1.694.347c.834-.667-.697-3.759 1.834-6.5z",
    "data-name": "Path 6222",
    transform: "translate(-.714 -1.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6223",
    fill: "#ff8300",
    d: "M12.917 11.57c1.67-1.816 2.472-2.564 2.839-4.9 2.78 2.112 1.12 5.384 2.618 5.726.748.17 1.612-.523 1.707-2.141 3.163 3.317.039 7.21 1.474 7.657.518.161 1.159-.472 1.159-.472a6.633 6.633 0 0 1-6.576 5.96A6.538 6.538 0 0 1 9.4 17.721s1.055.853 1.7.332c.832-.67-.685-3.762 1.817-6.483z",
    "data-name": "Path 6223",
    transform: "translate(-.728 -1.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6224",
    fill: "#ff8400",
    d: "M12.931 11.643c1.672-1.827 2.476-2.539 2.854-4.9 2.756 2.124 1.088 5.362 2.6 5.712.752.174 1.624-.52 1.722-2.127 3.125 3.295.012 7.189 1.448 7.644.52.165 1.166-.465 1.166-.465a6.628 6.628 0 0 1-6.567 5.926 6.535 6.535 0 0 1-6.721-5.64s1.06.841 1.7.318c.83-.679-.671-3.77 1.798-6.468z",
    "data-name": "Path 6224",
    transform: "translate(-.744 -1.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6225",
    fill: "#ff8500",
    d: "M12.943 11.716c1.674-1.838 2.481-2.514 2.868-4.907 2.732 2.137 1.057 5.341 2.582 5.7.756.177 1.636-.515 1.737-2.112 3.086 3.273-.015 7.169 1.421 7.632.521.168 1.173-.457 1.173-.457a6.623 6.623 0 0 1-6.558 5.892 6.531 6.531 0 0 1-6.708-5.6s1.065.83 1.706.3c.829-.682-.657-3.773 1.779-6.448z",
    "data-name": "Path 6225",
    transform: "translate(-.757 -1.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6226",
    fill: "#ff8600",
    d: "M12.956 11.788c1.676-1.849 2.486-2.49 2.882-4.909 2.708 2.149 1.025 5.32 2.565 5.683.761.18 1.649-.511 1.752-2.1 3.048 3.251-.042 7.147 1.4 7.619.522.171 1.181-.45 1.181-.45a6.619 6.619 0 0 1-6.548 5.858 6.528 6.528 0 0 1-6.695-5.565s1.069.819 1.71.288c.82-.681-.65-3.771 1.753-6.424z",
    "data-name": "Path 6226",
    transform: "translate(-.772 -1.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6227",
    fill: "#ff8700",
    d: "M12.969 11.86c1.678-1.861 2.49-2.465 2.9-4.912 2.684 2.161.994 5.3 2.546 5.669.765.183 1.661-.507 1.767-2.083 3.01 3.229-.069 7.127 1.369 7.607.523.175 1.189-.443 1.189-.443a6.615 6.615 0 0 1-6.54 5.823 6.526 6.526 0 0 1-6.682-5.527s1.074.807 1.715.273c.82-.686-.633-3.777 1.736-6.407z",
    "data-name": "Path 6227",
    transform: "translate(-.786 -1.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6228",
    fill: "#f80",
    d: "M12.981 11.933c1.679-1.872 2.495-2.441 2.91-4.914 2.66 2.174.962 5.277 2.528 5.655.769.186 1.674-.5 1.783-2.069 2.971 3.207-.1 7.106 1.343 7.595.524.178 1.2-.436 1.2-.436a6.612 6.612 0 0 1-6.53 5.789 6.524 6.524 0 0 1-6.669-5.489s1.079.8 1.719.259c.818-.692-.622-3.783 1.716-6.39z",
    "data-name": "Path 6228",
    transform: "translate(-.8 -2.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6229",
    fill: "#ff8900",
    d: "M12.994 12.005c1.68-1.883 2.5-2.416 2.925-4.917 2.637 2.187.931 5.256 2.51 5.641.774.189 1.686-.5 1.8-2.055 2.933 3.185-.124 7.085 1.316 7.582.525.181 1.2-.429 1.2-.429a6.608 6.608 0 0 1-6.521 5.755 6.521 6.521 0 0 1-6.654-5.45s1.084.785 1.723.244c.82-.696-.604-3.787 1.701-6.371z",
    "data-name": "Path 6229",
    transform: "translate(-.814 -2.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6230",
    fill: "#ff8a00",
    d: "M13.008 12.078c1.682-1.894 2.5-2.392 2.939-4.92 2.613 2.2.9 5.234 2.492 5.627.778.192 1.7-.495 1.812-2.041 2.9 3.163-.151 7.065 1.29 7.57.527.184 1.211-.421 1.211-.421a6.605 6.605 0 0 1-6.512 5.721A6.519 6.519 0 0 1 9.6 18.2s1.089.774 1.727.229c.816-.699-.594-3.79 1.681-6.351z",
    "data-name": "Path 6230",
    transform: "translate(-.828 -2.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6231",
    fill: "#ff8b00",
    d: "M13.021 12.15c1.683-1.906 2.509-2.367 2.953-4.922 2.589 2.211.868 5.213 2.474 5.613.782.2 1.711-.491 1.827-2.026 2.857 3.14-.178 7.044 1.264 7.557.528.188 1.219-.414 1.219-.414a6.6 6.6 0 0 1-6.5 5.687 6.517 6.517 0 0 1-6.629-5.375s1.094.763 1.731.214c.814-.704-.581-3.796 1.661-6.334z",
    "data-name": "Path 6231",
    transform: "translate(-.843 -2.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6232",
    fill: "#ff8c00",
    d: "M13.034 12.223C14.718 10.305 15.547 9.88 16 7.3c2.565 2.224.836 5.192 2.456 5.6.787.2 1.723-.487 1.843-2.012 2.819 3.118-.206 7.023 1.238 7.545.529.191 1.226-.407 1.226-.407a6.6 6.6 0 0 1-6.494 5.652 6.516 6.516 0 0 1-6.616-5.337s1.1.752 1.735.2c.812-.711-.563-3.803 1.646-6.318z",
    "data-name": "Path 6232",
    transform: "translate(-.858 -2.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6233",
    fill: "#ff8d00",
    d: "M13.046 12.3c1.685-1.929 2.518-2.318 2.981-4.927 2.541 2.236.805 5.17 2.437 5.585.791.2 1.735-.483 1.858-2 2.781 3.1-.233 7 1.212 7.532.53.195 1.234-.4 1.234-.4a6.6 6.6 0 0 1-6.484 5.618 6.516 6.516 0 0 1-6.6-5.3s1.1.741 1.739.184c.81-.713-.554-3.805 1.623-6.292z",
    "data-name": "Path 6233",
    transform: "translate(-.871 -2.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6234",
    fill: "#ff8e00",
    d: "M13.059 12.367c1.687-1.94 2.523-2.293 2.995-4.93 2.517 2.249.773 5.149 2.42 5.571.8.2 1.748-.479 1.873-1.983 2.742 3.074-.26 6.981 1.185 7.52.532.2 1.241-.392 1.241-.392a6.6 6.6 0 0 1-6.473 5.584 6.515 6.515 0 0 1-6.59-5.261s1.108.729 1.743.169c.81-.717-.539-3.809 1.606-6.278z",
    "data-name": "Path 6234",
    transform: "translate(-.886 -2.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6235",
    fill: "#ff8f00",
    d: "M13.072 12.441c1.687-1.952 2.527-2.269 3.009-4.933 2.494 2.261.742 5.127 2.4 5.557.8.207 1.76-.475 1.888-1.969 2.7 3.052-.287 6.961 1.159 7.507.533.2 1.249-.386 1.249-.386a6.594 6.594 0 0 1-6.466 5.55 6.515 6.515 0 0 1-6.577-5.223s1.114.719 1.747.155c.819-.719-.522-3.813 1.591-6.258z",
    "data-name": "Path 6235",
    transform: "translate(-.9 -2.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6236",
    fill: "#ff9000",
    d: "M13.085 12.512c1.688-1.964 2.532-2.244 3.023-4.935 2.47 2.273.711 5.106 2.383 5.543.8.21 1.773-.47 1.9-1.954 2.666 3.03-.314 6.94 1.133 7.5.534.2 1.256-.378 1.256-.378a6.593 6.593 0 0 1-6.453 5.512 6.516 6.516 0 0 1-6.564-5.186s1.119.708 1.751.14c.811-.725-.514-3.82 1.571-6.242z",
    "data-name": "Path 6236",
    transform: "translate(-.914 -2.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6237",
    fill: "#ff9100",
    d: "M13.1 12.585c1.689-1.976 2.536-2.22 3.037-4.938 2.446 2.286.679 5.084 2.365 5.529.808.213 1.785-.467 1.918-1.94 2.628 3.008-.341 6.919 1.107 7.483.535.208 1.264-.371 1.264-.371a6.592 6.592 0 0 1-6.447 5.481 6.516 6.516 0 0 1-6.554-5.148s1.124.7 1.756.125c.809-.727-.499-3.822 1.554-6.221z",
    "data-name": "Path 6237",
    transform: "translate(-.928 -2.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6238",
    fill: "#ff9200",
    d: "M13.111 12.658c1.69-1.988 2.541-2.2 3.052-4.941 2.422 2.3.648 5.063 2.347 5.515.813.216 1.8-.462 1.933-1.926 2.59 2.986-.369 6.9 1.081 7.47.536.211 1.272-.364 1.272-.364a6.592 6.592 0 0 1-6.438 5.447 6.517 6.517 0 0 1-6.538-5.11s1.129.685 1.759.11c.806-.73-.486-3.826 1.532-6.201z",
    "data-name": "Path 6238",
    transform: "translate(-.943 -2.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6239",
    fill: "#ff9300",
    d: "M13.123 12.73c1.69-2 2.545-2.171 3.066-4.943 2.4 2.311.616 5.041 2.329 5.5.817.219 1.81-.458 1.948-1.911 2.552 2.964-.4 6.878 1.054 7.458.537.215 1.279-.357 1.279-.357a6.592 6.592 0 0 1-6.429 5.413 6.519 6.519 0 0 1-6.525-5.072s1.134.674 1.764.1c.805-.74-.473-3.837 1.514-6.188z",
    "data-name": "Path 6239",
    transform: "translate(-.956 -2.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6240",
    fill: "#ff9400",
    d: "M13.136 12.8c1.691-2.012 2.55-2.147 3.08-4.946 2.374 2.323.585 5.02 2.311 5.487.821.222 1.823-.455 1.963-1.9 2.513 2.942-.423 6.857 1.028 7.445.538.218 1.287-.35 1.287-.35a6.593 6.593 0 0 1-6.42 5.379 6.521 6.521 0 0 1-6.512-5.034s1.139.663 1.768.081c.804-.734-.461-3.832 1.495-6.162z",
    "data-name": "Path 6240",
    transform: "translate(-.971 -2.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6241",
    fill: "#ff9500",
    d: "M13.15 12.875c1.691-2.024 2.554-2.122 3.094-4.948 2.35 2.335.553 5 2.293 5.472.826.225 1.835-.45 1.978-1.883 2.475 2.92-.451 6.837 1 7.433.54.221 1.294-.342 1.294-.342a6.593 6.593 0 0 1-6.409 5.345 6.522 6.522 0 0 1-6.5-5s1.144.651 1.772.066c.804-.741-.446-3.839 1.478-6.143z",
    "data-name": "Path 6241",
    transform: "translate(-.986 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6242",
    fill: "#ff9600",
    d: "M13.162 12.948c1.691-2.037 2.559-2.1 3.108-4.951 2.327 2.348.522 4.977 2.275 5.458.83.228 1.847-.446 1.993-1.868 2.436 2.9-.478 6.816.976 7.42.541.225 1.3-.335 1.3-.335a6.594 6.594 0 0 1-6.4 5.311 6.525 6.525 0 0 1-6.486-4.958s1.148.64 1.776.051c.801-.749-.435-3.848 1.458-6.128z",
    "data-name": "Path 6242",
    transform: "translate(-1 -2.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6243",
    fill: "#ff9700",
    d: "M13.176 13.02c1.691-2.049 2.564-2.073 3.123-4.954 2.3 2.36.491 4.956 2.257 5.444.834.231 1.86-.442 2.008-1.854 2.4 2.876-.505 6.8.95 7.408.542.228 1.309-.328 1.309-.328a6.6 6.6 0 0 1-6.392 5.276 6.528 6.528 0 0 1-6.473-4.921s1.153.629 1.78.037c.798-.751-.424-3.851 1.438-6.108z",
    "data-name": "Path 6243",
    transform: "translate(-1.015 -2.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6244",
    fill: "#ff9800",
    d: "M13.188 13.092c1.691-2.062 2.568-2.048 3.137-4.956 2.279 2.373.459 4.934 2.239 5.43.839.234 1.872-.438 2.023-1.839 2.36 2.853-.532 6.775.924 7.395.543.232 1.316-.321 1.316-.321a6.6 6.6 0 0 1-6.383 5.242 6.531 6.531 0 0 1-6.46-4.882s1.158.618 1.784.022c.797-.757-.411-3.858 1.42-6.091z",
    "data-name": "Path 6244",
    transform: "translate(-1.028 -2.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6245",
    fill: "#f90",
    d: "M13.2 13.165c1.69-2.074 2.573-2.024 3.151-4.959 2.255 2.385.428 4.912 2.22 5.416.843.237 1.884-.434 2.038-1.825 2.322 2.831-.56 6.754.9 7.383.544.235 1.324-.313 1.324-.313a6.6 6.6 0 0 1-12.821.363s1.163.607 1.788.007c.8-.761-.4-3.863 1.4-6.072z",
    "data-name": "Path 6245",
    transform: "translate(-1.043 -2.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6246",
    fill: "#ff9a00",
    d: "M13.214 13.237c1.69-2.087 2.578-2 3.165-4.961 2.231 2.4.4 4.891 2.2 5.4.847.24 1.9-.43 2.053-1.811 2.284 2.81-.587 6.733.871 7.37.546.238 1.332-.306 1.332-.306a6.6 6.6 0 0 1-12.8.367s1.168.6 1.792-.008c.799-.763-.382-3.865 1.387-6.051z",
    "data-name": "Path 6246",
    transform: "translate(-1.057 -2.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6247",
    fill: "#ff9b00",
    d: "M13.226 13.309c1.689-2.1 2.582-1.975 3.179-4.964 2.207 2.41.365 4.869 2.184 5.388.852.243 1.909-.426 2.068-1.8 2.246 2.787-.614 6.713.845 7.358.547.242 1.339-.3 1.339-.3a6.6 6.6 0 0 1-12.776.371s1.172.584 1.8-.023c.79-.764-.377-3.868 1.361-6.03z",
    "data-name": "Path 6247",
    transform: "translate(-1.071 -2.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6248",
    fill: "#ff9c00",
    d: "M13.239 13.383c1.688-2.113 2.587-1.95 3.193-4.967 2.184 2.422.334 4.848 2.166 5.374.856.246 1.921-.422 2.083-1.782 2.207 2.765-.641 6.692.819 7.345.548.245 1.347-.292 1.347-.292a6.611 6.611 0 0 1-6.347 5.106c-2.326 0-5.6-1.4-6.408-4.731 0 0 1.177.573 1.8-.038.793-.773-.36-3.878 1.347-6.015z",
    "data-name": "Path 6248",
    transform: "translate(-1.085 -2.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6249",
    fill: "#ff9d00",
    d: "M13.252 13.455c1.687-2.126 2.591-1.926 3.207-4.97 2.16 2.435.3 4.826 2.148 5.36a1.8 1.8 0 0 0 2.1-1.768c2.169 2.743-.669 6.672.793 7.333.549.248 1.354-.285 1.354-.285a6.616 6.616 0 0 1-6.338 5.075c-2.307 0-5.573-1.385-6.395-4.693 0 0 1.182.562 1.8-.052.795-.781-.345-3.887 1.331-6z",
    "data-name": "Path 6249",
    transform: "translate(-1.1 -2.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6250",
    fill: "#ff9e00",
    d: "M13.265 13.527c1.686-2.139 2.6-1.9 3.221-4.972 2.136 2.448.271 4.8 2.13 5.346a1.8 1.8 0 0 0 2.113-1.754c2.131 2.721-.7 6.651.767 7.32.55.252 1.362-.277 1.362-.277a6.621 6.621 0 0 1-6.328 5.037c-2.288 0-5.549-1.375-6.381-4.655 0 0 1.187.55 1.809-.067.788-.781-.339-3.889 1.307-5.978z",
    "data-name": "Path 6250",
    transform: "translate(-1.114 -2.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6251",
    fill: "#ff9f00",
    d: "M13.278 13.6c1.684-2.153 2.6-1.876 3.236-4.975 2.112 2.46.24 4.783 2.112 5.332a1.806 1.806 0 0 0 2.128-1.739c2.093 2.7-.723 6.63.74 7.308.551.255 1.369-.27 1.369-.27a6.627 6.627 0 0 1-6.319 5c-2.268 0-5.526-1.364-6.368-4.617 0 0 1.192.539 1.812-.082.788-.784-.326-3.892 1.29-5.957z",
    "data-name": "Path 6251",
    transform: "translate(-1.128 -2.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6252",
    fill: "#ffa000",
    d: "M13.29 13.672c1.683-2.166 2.6-1.852 3.25-4.977 2.088 2.472.209 4.758 2.094 5.318a1.811 1.811 0 0 0 2.143-1.725c2.055 2.677-.752 6.613.714 7.3.552.26 1.377-.263 1.377-.263a6.633 6.633 0 0 1-6.309 4.969c-2.249 0-5.5-1.353-6.355-4.579 0 0 1.2.528 1.817-.1.785-.792-.316-3.902 1.269-5.943z",
    "data-name": "Path 6252",
    transform: "translate(-1.142 -2.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6253",
    fill: "#ffa100",
    d: "M13.305 13.745c1.681-2.18 2.61-1.827 3.264-4.98 2.064 2.485.178 4.738 2.076 5.3a1.817 1.817 0 0 0 2.159-1.71c2.017 2.655-.779 6.591.688 7.283.553.263 1.384-.256 1.384-.256a6.64 6.64 0 0 1-6.3 4.934c-2.23 0-5.478-1.342-6.342-4.542 0 0 1.2.517 1.821-.112.782-.789-.305-3.9 1.25-5.917z",
    "data-name": "Path 6253",
    transform: "translate(-1.158 -2.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6254",
    fill: "#ffa200",
    d: "M13.318 13.818c1.679-2.194 2.614-1.8 3.278-4.983 2.041 2.5.146 4.716 2.057 5.29a1.822 1.822 0 0 0 2.174-1.7c1.978 2.633-.806 6.57.662 7.271.554.266 1.392-.249 1.392-.249a6.647 6.647 0 0 1-6.291 4.9c-2.211 0-5.455-1.332-6.329-4.5 0 0 1.207.506 1.825-.127.781-.797-.294-3.91 1.232-5.902z",
    "data-name": "Path 6254",
    transform: "translate(-1.172 -2.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6255",
    fill: "#ffa300",
    d: "M13.33 13.89c1.677-2.207 2.619-1.778 3.292-4.985 2.017 2.51.115 4.7 2.04 5.276A1.828 1.828 0 0 0 20.85 12.5c1.94 2.611-.833 6.549.636 7.258.556.269 1.4-.242 1.4-.242a6.655 6.655 0 0 1-6.286 4.865c-2.191 0-5.431-1.321-6.316-4.465 0 0 1.211.494 1.829-.141.787-.803-.278-3.917 1.217-5.885z",
    "data-name": "Path 6255",
    transform: "translate(-1.186 -3.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6256",
    fill: "#ffa400",
    d: "M13.343 13.962c1.674-2.222 2.624-1.754 3.306-4.988 1.993 2.522.083 4.674 2.021 5.262a1.833 1.833 0 0 0 2.2-1.667c1.9 2.589-.86 6.528.609 7.246.557.273 1.407-.234 1.407-.234a6.664 6.664 0 0 1-6.273 4.831c-2.172 0-5.407-1.311-6.3-4.427 0 0 1.216.483 1.833-.156.78-.807-.269-3.923 1.197-5.867z",
    "data-name": "Path 6256",
    transform: "translate(-1.2 -3.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6257",
    fill: "orange",
    d: "M13.356 14.034c1.671-2.236 2.628-1.729 3.32-4.99 1.969 2.534.052 4.653 2 5.247a1.84 1.84 0 0 0 2.224-1.653c1.863 2.566-.887 6.507.583 7.233.558.276 1.415-.227 1.415-.227a6.673 6.673 0 0 1-6.263 4.8c-2.153 0-5.383-1.3-6.29-4.39 0 0 1.221.472 1.837-.171.775-.812-.262-3.928 1.174-5.849z",
    "data-name": "Path 6257",
    transform: "translate(-1.214 -3.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6258",
    fill: "#ffa600",
    d: "M13.368 14.107C15.037 11.857 16 12.4 16.7 9.114c1.945 2.547.02 4.632 1.985 5.234a1.846 1.846 0 0 0 2.234-1.639c1.825 2.544-.915 6.486.557 7.221.559.279 1.422-.22 1.422-.22a6.683 6.683 0 0 1-6.254 4.763c-2.134 0-5.36-1.289-6.277-4.352 0 0 1.226.46 1.841-.186.778-.814-.245-3.935 1.16-5.828z",
    "data-name": "Path 6258",
    transform: "translate(-1.228 -3.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6259",
    fill: "#ffa701",
    d: "M13.445 14.379c1.647-2.216 2.613-1.716 3.3-4.93 1.933 2.522.044 4.58 1.974 5.173a1.832 1.832 0 0 0 2.226-1.6c1.788 2.52-.909 6.373.546 7.119.551.281 1.42-.206 1.42-.206a6.638 6.638 0 0 1-6.211 4.707c-2.113 0-5.319-1.275-6.226-4.3.005 0 1.224.449 1.832-.194.763-.811-.259-3.892 1.139-5.769z",
    "data-name": "Path 6259",
    transform: "translate(-1.281 -3.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6260",
    fill: "#ffa802",
    d: "M13.52 14.65c1.626-2.182 2.593-1.728 3.261-4.867 1.921 2.5.068 4.528 1.963 5.112a1.819 1.819 0 0 0 2.218-1.561c1.75 2.5-.9 6.264.534 7.016.542.284 1.418-.193 1.418-.193a6.593 6.593 0 0 1-6.169 4.653c-2.093 0-5.277-1.261-6.175-4.245.011.007 1.222.437 1.822-.2.759-.813-.261-3.856 1.128-5.715z",
    "data-name": "Path 6260",
    transform: "translate(-1.333 -3.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6261",
    fill: "#ffa903",
    d: "M13.6 14.921c1.6-2.148 2.574-1.739 3.224-4.8 1.909 2.473.093 4.476 1.952 5.051a1.805 1.805 0 0 0 2.21-1.522c1.712 2.472-.9 6.153.523 6.914.534.286 1.415-.179 1.415-.179a6.547 6.547 0 0 1-6.126 4.6c-2.073 0-5.236-1.247-6.124-4.192.016.011 1.22.426 1.812-.21.748-.816-.272-3.821 1.114-5.662z",
    "data-name": "Path 6261",
    transform: "translate(-1.384 -3.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6262",
    fill: "#ffa904",
    d: "M13.672 15.192c1.583-2.113 2.554-1.751 3.187-4.74 1.9 2.448.118 4.419 1.941 4.99a1.793 1.793 0 0 0 2.2-1.483c1.674 2.447-.893 6.041.512 6.811.525.288 1.413-.165 1.413-.165a6.5 6.5 0 0 1-6.083 4.544c-2.053 0-5.195-1.234-6.074-4.138.021.014 1.218.414 1.8-.218.748-.81-.268-3.778 1.104-5.601z",
    "data-name": "Path 6262",
    transform: "translate(-1.436 -3.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6263",
    fill: "#ffaa05",
    d: "M13.747 15.463c1.562-2.079 2.534-1.762 3.15-4.677 1.886 2.423.143 4.366 1.93 4.929a1.78 1.78 0 0 0 2.194-1.445c1.636 2.422-.888 5.93.5 6.709.517.29 1.41-.151 1.41-.151a6.457 6.457 0 0 1-6.041 4.489c-2.032 0-5.154-1.22-6.023-4.085.026.018 1.216.4 1.793-.226.74-.806-.279-3.738 1.087-5.543z",
    "data-name": "Path 6263",
    transform: "translate(-1.488 -3.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6264",
    fill: "#ffab06",
    d: "M13.823 15.734c1.545-2.042 2.514-1.774 3.113-4.614 1.874 2.4.167 4.313 1.919 4.869a1.768 1.768 0 0 0 2.186-1.406c1.6 2.4-.883 5.819.489 6.607.508.292 1.408-.137 1.408-.137a6.412 6.412 0 0 1-6 4.434c-2.012 0-5.113-1.206-5.972-4.031.031.022 1.215.392 1.783-.234.733-.807-.28-3.698 1.074-5.488z",
    "data-name": "Path 6264",
    transform: "translate(-1.539 -4.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6265",
    fill: "#ffac07",
    d: "M13.9 16.005c1.524-2.007 2.5-1.785 3.076-4.55 1.862 2.374.192 4.26 1.908 4.808a1.755 1.755 0 0 0 2.178-1.363c1.561 2.374-.877 5.707.478 6.5.5.294 1.406-.124 1.406-.124a6.367 6.367 0 0 1-5.955 4.379c-1.992 0-5.071-1.192-5.921-3.978.037.025 1.213.38 1.773-.242.723-.804-.289-3.658 1.057-5.43z",
    "data-name": "Path 6265",
    transform: "translate(-1.592 -4.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6266",
    fill: "#ffad08",
    d: "M13.975 16.276c1.5-1.972 2.475-1.8 3.039-4.487 1.849 2.349.216 4.207 1.9 4.747a1.743 1.743 0 0 0 2.17-1.328c1.523 2.35-.872 5.6.466 6.4.491.3 1.4-.11 1.4-.11a6.322 6.322 0 0 1-5.912 4.324c-1.972 0-5.03-1.178-5.87-3.924.042.029 1.211.369 1.763-.25.717-.801-.294-3.617 1.044-5.372z",
    "data-name": "Path 6266",
    transform: "translate(-1.643 -4.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6267",
    fill: "#ffae09",
    d: "M14.051 16.547c1.483-1.938 2.456-1.809 3-4.424 1.838 2.324.241 4.154 1.886 4.686A1.731 1.731 0 0 0 21.1 15.52c1.485 2.325-.866 5.483.455 6.3.482.3 1.4-.1 1.4-.1a6.277 6.277 0 0 1-5.87 4.269c-1.952 0-4.989-1.164-5.819-3.87.047.032 1.21.357 1.753-.259.711-.798-.298-3.576 1.032-5.313z",
    "data-name": "Path 6267",
    transform: "translate(-1.695 -4.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6268",
    fill: "#ffae0a",
    d: "M14.126 16.819c1.462-1.9 2.436-1.82 2.966-4.361 1.826 2.3.265 4.1 1.875 4.625a1.719 1.719 0 0 0 2.154-1.25c1.447 2.3-.861 5.372.443 6.2.474.3 1.4-.082 1.4-.082a6.232 6.232 0 0 1-5.827 4.214c-1.931 0-4.948-1.15-5.768-3.817.052.036 1.208.346 1.744-.266.699-.804-.308-3.544 1.013-5.263z",
    "data-name": "Path 6268",
    transform: "translate(-1.746 -4.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6269",
    fill: "#ffaf0b",
    d: "M14.2 17.089c1.441-1.869 2.416-1.832 2.929-4.3 1.814 2.275.29 4.048 1.864 4.564a1.707 1.707 0 0 0 2.146-1.212c1.409 2.277-.856 5.26.432 6.1.466.3 1.4-.068 1.4-.068a6.188 6.188 0 0 1-5.784 4.159c-1.911 0-4.907-1.136-5.717-3.763.058.039 1.206.334 1.734-.274.696-.802-.314-3.504.996-5.206z",
    "data-name": "Path 6269",
    transform: "translate(-1.799 -5.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6270",
    fill: "#ffb00c",
    d: "M14.278 17.36c1.42-1.834 2.4-1.844 2.892-4.234 1.8 2.251.314 4 1.853 4.5a1.7 1.7 0 0 0 2.138-1.173c1.372 2.252-.85 5.148.421 5.993.457.3 1.394-.055 1.394-.055a6.143 6.143 0 0 1-5.741 4.1c-1.89 0-4.865-1.122-5.666-3.71.063.043 1.2.323 1.724-.283.686-.789-.318-3.454.985-5.138z",
    "data-name": "Path 6270",
    transform: "translate(-1.851 -5.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6271",
    fill: "#ffb10d",
    d: "M14.353 17.632c1.4-1.8 2.377-1.855 2.855-4.171C19 15.687 17.546 17.4 19.05 17.9a1.684 1.684 0 0 0 2.13-1.134c1.334 2.227-.845 5.036.41 5.891.448.306 1.392-.041 1.392-.041a6.1 6.1 0 0 1-5.7 4.049c-1.87 0-4.824-1.108-5.615-3.657.068.047 1.2.311 1.714-.291.679-.792-.323-3.417.972-5.085z",
    "data-name": "Path 6271",
    transform: "translate(-1.902 -5.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6272",
    fill: "#ffb20e",
    d: "M14.429 17.9c1.379-1.765 2.357-1.867 2.818-4.108 1.778 2.2.363 3.89 1.831 4.382a1.672 1.672 0 0 0 2.122-1.1c1.3 2.2-.839 4.923.4 5.788.44.308 1.39-.027 1.39-.027a6.054 6.054 0 0 1-5.656 3.994c-1.85 0-4.783-1.094-5.564-3.6.074.05 1.2.3 1.7-.3.673-.789-.328-3.378.959-5.029z",
    "data-name": "Path 6272",
    transform: "translate(-1.954 -5.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6273",
    fill: "#ffb30f",
    d: "M14.505 18.174c1.358-1.731 2.338-1.878 2.781-4.045 1.766 2.176.388 3.837 1.82 4.321a1.661 1.661 0 0 0 2.115-1.056c1.258 2.179-.833 4.811.387 5.686.431.309 1.387-.013 1.387-.013a6.009 6.009 0 0 1-5.613 3.939c-1.83 0-4.742-1.081-5.514-3.55.079.054 1.2.288 1.695-.307.662-.793-.337-3.349.942-4.975z",
    "data-name": "Path 6273",
    transform: "translate(-2.006 -5.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6274",
    fill: "#ffb310",
    d: "M14.581 18.445c1.337-1.7 2.318-1.89 2.745-3.981 1.754 2.152.412 3.785 1.809 4.26a1.65 1.65 0 0 0 2.107-1.018c1.221 2.155-.828 4.7.376 5.584.423.311 1.385 0 1.385 0a5.964 5.964 0 0 1-5.57 3.884c-1.81 0-4.7-1.067-5.463-3.5a1.766 1.766 0 0 0 1.685-.315c.653-.787-.345-3.301.926-4.914z",
    "data-name": "Path 6274",
    transform: "translate(-2.058 -5.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6275",
    fill: "#ffb411",
    d: "M14.657 18.716c1.316-1.662 2.3-1.9 2.708-3.918 1.742 2.127.436 3.732 1.8 4.2a1.639 1.639 0 0 0 2.1-.979c1.183 2.13-.822 4.586.364 5.481.415.312 1.383.014 1.383.014a5.92 5.92 0 0 1-5.527 3.829c-1.789 0-4.66-1.053-5.412-3.443a1.753 1.753 0 0 0 1.675-.323c.643-.79-.353-3.266.909-4.861z",
    "data-name": "Path 6275",
    transform: "translate(-2.11 -6.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6276",
    fill: "#ffb512",
    d: "M14.732 18.988c1.295-1.627 2.278-1.913 2.67-3.855 1.731 2.1.461 3.679 1.787 4.139a1.628 1.628 0 0 0 2.091-.94c1.145 2.106-.817 4.474.353 5.379.406.314 1.38.028 1.38.028a5.875 5.875 0 0 1-5.485 3.775c-1.769 0-4.618-1.039-5.361-3.389a1.741 1.741 0 0 0 1.666-.331c.639-.794-.355-3.23.899-4.806z",
    "data-name": "Path 6276",
    transform: "translate(-2.161 -6.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6277",
    fill: "#ffb613",
    d: "M14.809 19.259c1.274-1.593 2.259-1.925 2.634-3.791 1.719 2.078.485 3.627 1.776 4.077a1.617 1.617 0 0 0 2.083-.9c1.107 2.082-.811 4.361.342 5.277.4.316 1.378.041 1.378.041a5.831 5.831 0 0 1-5.442 3.72c-1.749 0-4.577-1.025-5.31-3.336a1.729 1.729 0 0 0 1.656-.339c.63-.79-.363-3.19.883-4.749z",
    "data-name": "Path 6277",
    transform: "translate(-2.214 -6.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6278",
    fill: "#ffb714",
    d: "M14.884 19.53c1.252-1.559 2.239-1.936 2.6-3.728 1.706 2.053.509 3.574 1.765 4.017a1.607 1.607 0 0 0 2.075-.862c1.069 2.057-.806 4.248.33 5.174.39.318 1.376.055 1.376.055a5.787 5.787 0 0 1-5.4 3.665c-1.729 0-4.536-1.011-5.259-3.282a1.717 1.717 0 0 0 1.646-.347c.621-.788-.371-3.151.867-4.692z",
    "data-name": "Path 6278",
    transform: "translate(-2.265 -6.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6279",
    d: "M14.96 19.8c1.231-1.524 2.22-1.948 2.56-3.665 1.694 2.028.534 3.522 1.754 3.956a1.6 1.6 0 0 0 2.067-.824c1.031 2.033-.8 4.136.319 5.072.381.319 1.373.069 1.373.069a5.742 5.742 0 0 1-5.356 3.61c-1.708 0-4.494-1-5.208-3.229a1.7 1.7 0 0 0 1.636-.355c.616-.785-.374-3.11.855-4.634z",
    className: "prefix__cls-107",
    "data-name": "Path 6279",
    transform: "translate(-2.318 -6.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6280",
    d: "M15.036 20.073c1.21-1.49 2.2-1.959 2.523-3.6 1.683 2 .558 3.47 1.743 3.895a1.586 1.586 0 0 0 2.059-.785c.994 2.008-.794 4.023.308 4.97.373.321 1.371.083 1.371.083a5.7 5.7 0 0 1-5.314 3.555c-1.688 0-4.453-.983-5.157-3.175a1.69 1.69 0 0 0 1.631-.366c.6-.785-.386-3.073.836-4.577z",
    className: "prefix__cls-107",
    "data-name": "Path 6280",
    transform: "translate(-2.369 -6.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6281",
    fill: "#ffb916",
    d: "M15.112 20.344c1.189-1.456 2.18-1.971 2.486-3.539 1.671 1.979.583 3.418 1.732 3.834a1.576 1.576 0 0 0 2.051-.746c.956 1.984-.788 3.91.3 4.868.365.322 1.369.1 1.369.1a5.655 5.655 0 0 1-5.271 3.5c-1.668 0-4.412-.969-5.106-3.122a1.677 1.677 0 0 0 1.616-.372c.596-.787-.389-3.037.823-4.523z",
    "data-name": "Path 6281",
    transform: "translate(-2.421 -7.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6282",
    fill: "#ffba17",
    d: "M15.187 20.615c1.167-1.422 2.161-1.982 2.449-3.475 1.659 1.954.607 3.365 1.721 3.774a1.564 1.564 0 0 0 2.043-.707c.918 1.96-.782 3.8.285 4.765.356.324 1.367.11 1.367.11a5.611 5.611 0 0 1-5.228 3.445c-1.647 0-4.371-.955-5.055-3.068a1.665 1.665 0 0 0 1.607-.379c.592-.78-.395-2.996.811-4.465z",
    "data-name": "Path 6282",
    transform: "translate(-2.472 -7.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6283",
    fill: "#ffbb18",
    d: "M15.263 20.886c1.146-1.388 2.141-1.994 2.412-3.412 1.647 1.929.631 3.313 1.71 3.712a1.554 1.554 0 0 0 2.035-.668c.88 1.935-.776 3.683.274 4.663.348.325 1.364.124 1.364.124a5.566 5.566 0 0 1-5.185 3.39c-1.627 0-4.33-.941-5-3.015a1.652 1.652 0 0 0 1.6-.388c.577-.781-.408-2.955.79-4.406z",
    "data-name": "Path 6283",
    transform: "translate(-2.525 -7.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6284",
    fill: "#ffbc19",
    d: "M15.339 21.157c1.124-1.354 2.121-2.005 2.376-3.349 1.635 1.9.655 3.261 1.7 3.652a1.543 1.543 0 0 0 2.027-.63c.843 1.911-.769 3.57.262 4.56.34.326 1.362.138 1.362.138a5.523 5.523 0 0 1-5.142 3.335c-1.607 0-4.288-.927-4.953-2.961a1.637 1.637 0 0 0 1.588-.4c.574-.776-.41-2.912.78-4.345z",
    "data-name": "Path 6284",
    transform: "translate(-2.577 -7.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6285",
    fill: "#ffbc1a",
    d: "M15.415 21.428c1.1-1.319 2.1-2.017 2.339-3.285 1.623 1.88.679 3.209 1.688 3.591a1.533 1.533 0 0 0 2.019-.591c.8 1.887-.763 3.457.251 4.458.332.328 1.36.152 1.36.152a5.479 5.479 0 0 1-5.1 3.281c-1.587 0-4.247-.913-4.9-2.908a1.624 1.624 0 0 0 1.577-.4c.567-.784-.416-2.883.766-4.298z",
    "data-name": "Path 6285",
    transform: "translate(-2.629 -7.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6286",
    fill: "#ffbd1b",
    d: "M15.49 21.7c1.081-1.286 2.082-2.029 2.3-3.222 1.611 1.855.7 3.158 1.677 3.53a1.523 1.523 0 0 0 2.011-.552c.767 1.862-.757 3.343.24 4.356.324.329 1.357.165 1.357.165A5.435 5.435 0 0 1 18.02 29.2c-1.566 0-4.206-.9-4.852-2.854a1.61 1.61 0 0 0 1.568-.412c.564-.777-.421-2.834.754-4.234z",
    "data-name": "Path 6286",
    transform: "translate(-2.68 -7.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6287",
    fill: "#ffbe1c",
    d: "M15.567 21.97c1.06-1.251 2.062-2.04 2.265-3.159 1.6 1.831.728 3.106 1.666 3.469a1.512 1.512 0 0 0 2-.513c.729 1.838-.75 3.229.229 4.254.316.33 1.355.179 1.355.179a5.391 5.391 0 0 1-5.014 3.17c-1.546 0-4.165-.885-4.8-2.8a1.6 1.6 0 0 0 1.558-.42c.554-.778-.426-2.802.741-4.18z",
    "data-name": "Path 6287",
    transform: "translate(-2.732 -8.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6288",
    fill: "#ffbf1d",
    d: "M15.642 22.242c1.038-1.218 2.043-2.052 2.228-3.1 1.587 1.806.752 3.054 1.655 3.409a1.5 1.5 0 0 0 2-.474c.691 1.813-.743 3.116.217 4.151.308.332 1.353.193 1.353.193a5.347 5.347 0 0 1-4.972 3.115c-1.526 0-4.124-.872-4.75-2.747a1.583 1.583 0 0 0 1.548-.428c.541-.773-.438-2.761.721-4.119z",
    "data-name": "Path 6288",
    transform: "translate(-2.784 -8.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6289",
    fill: "#ffc01e",
    d: "M15.718 22.513c1.016-1.184 2.023-2.064 2.191-3.033 1.575 1.782.776 3 1.644 3.347a1.491 1.491 0 0 0 1.988-.436c.653 1.789-.737 3 .206 4.049.3.333 1.35.207 1.35.207a5.3 5.3 0 0 1-4.929 3.06c-1.506 0-4.083-.858-4.7-2.694a1.569 1.569 0 0 0 1.538-.436c.538-.777-.44-2.723.712-4.064z",
    "data-name": "Path 6289",
    transform: "translate(-2.836 -8.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6290",
    fill: "#ffc11f",
    d: "M15.793 22.783c.995-1.15 2-2.075 2.154-2.969 1.563 1.757.8 2.951 1.633 3.287a1.479 1.479 0 0 0 1.979-.4c.616 1.765-.729 2.888.195 3.946.292.334 1.348.221 1.348.221a5.261 5.261 0 0 1-4.886 3.006c-1.485 0-4.041-.844-4.648-2.641a1.555 1.555 0 0 0 1.529-.444c.528-.771-.448-2.682.696-4.006z",
    "data-name": "Path 6290",
    transform: "translate(-2.887 -8.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6291",
    fill: "#ffc120",
    d: "M15.871 23.055c.973-1.116 1.984-2.087 2.118-2.906 1.551 1.732.824 2.9 1.622 3.226a1.469 1.469 0 0 0 1.972-.358c.578 1.74-.723 2.774.183 3.844.284.335 1.346.234 1.346.234a5.217 5.217 0 0 1-4.843 2.951c-1.465 0-4-.83-4.6-2.587a1.541 1.541 0 0 0 1.519-.453c.521-.772-.455-2.646.683-3.951z",
    "data-name": "Path 6291",
    transform: "translate(-2.94 -8.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6292",
    fill: "#ffc221",
    d: "M15.946 23.326c.951-1.082 1.964-2.1 2.081-2.843 1.539 1.707.848 2.848 1.611 3.165a1.457 1.457 0 0 0 1.964-.319c.54 1.716-.716 2.66.172 3.742.276.337 1.343.248 1.343.248a5.174 5.174 0 0 1-4.8 2.9c-1.445 0-3.959-.816-4.546-2.534a1.528 1.528 0 0 0 1.509-.46c.511-.776-.464-2.613.666-3.899z",
    "data-name": "Path 6292",
    transform: "translate(-2.992 -9.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6293",
    fill: "#ffc322",
    d: "M16.021 23.6c.929-1.049 1.944-2.11 2.044-2.78 1.528 1.682.872 2.8 1.6 3.1a1.446 1.446 0 0 0 1.956-.28c.5 1.692-.708 2.546.161 3.64.268.338 1.341.261 1.341.261a5.13 5.13 0 0 1-4.758 2.841c-1.425 0-3.918-.8-4.5-2.48a1.514 1.514 0 0 0 1.5-.469c.508-.769-.465-2.569.656-3.833z",
    "data-name": "Path 6293",
    transform: "translate(-3.043 -9.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6294",
    fill: "#ffc423",
    d: "M16.1 23.868c.907-1.015 1.925-2.122 2.007-2.716 1.516 1.658.9 2.746 1.589 3.043a1.434 1.434 0 0 0 1.948-.242c.465 1.667-.7 2.432.149 3.537.26.339 1.339.275 1.339.275a5.087 5.087 0 0 1-4.715 2.786c-1.4 0-3.877-.788-4.444-2.426a1.5 1.5 0 0 0 1.49-.477c.491-.768-.482-2.531.637-3.78z",
    "data-name": "Path 6294",
    transform: "translate(-3.094 -9.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6295",
    fill: "#ffc524",
    d: "M16.173 24.139a9.216 9.216 0 0 0 1.97-2.653c1.5 1.633.919 2.695 1.578 2.982a1.423 1.423 0 0 0 1.94-.2c.427 1.643-.692 2.317.138 3.435.253.34 1.337.289 1.337.289a5.044 5.044 0 0 1-4.673 2.731c-1.384 0-3.835-.774-4.393-2.373a1.485 1.485 0 0 0 1.48-.485c.487-.77-.485-2.496.623-3.726z",
    "data-name": "Path 6295",
    transform: "translate(-3.147 -9.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6296",
    fill: "#ffc625",
    d: "M16.249 24.41a9.536 9.536 0 0 0 1.933-2.59c1.492 1.609.943 2.644 1.567 2.922a1.411 1.411 0 0 0 1.932-.164c.389 1.618-.685 2.2.127 3.333.245.341 1.334.3 1.334.3a5 5 0 0 1-4.63 2.676c-1.364 0-3.794-.76-4.342-2.319a1.471 1.471 0 0 0 1.47-.493c.479-.765-.493-2.454.609-3.665z",
    "data-name": "Path 6296",
    transform: "translate(-3.199 -9.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6297",
    fill: "#ffc626",
    d: "M16.324 24.681a9.936 9.936 0 0 0 1.9-2.526c1.48 1.584.967 2.593 1.556 2.861a1.4 1.4 0 0 0 1.92-.126c.351 1.594-.677 2.089.116 3.23.237.342 1.332.317 1.332.317a4.958 4.958 0 0 1-4.587 2.621c-1.343 0-3.753-.746-4.292-2.266a1.457 1.457 0 0 0 1.46-.5c.471-.767-.499-2.419.595-3.611z",
    "data-name": "Path 6297",
    transform: "translate(-3.25 -9.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6298",
    fill: "#ffc727",
    d: "M16.4 24.952a10.435 10.435 0 0 0 1.859-2.463c1.468 1.559.99 2.543 1.545 2.8a1.386 1.386 0 0 0 1.916-.089c.313 1.57-.668 1.974.1 3.128.23.343 1.329.33 1.329.33a4.915 4.915 0 0 1-4.544 2.566c-1.323 0-3.712-.732-4.241-2.213a1.444 1.444 0 0 0 1.451-.509c.466-.763-.504-2.377.585-3.55z",
    "data-name": "Path 6298",
    transform: "translate(-3.302 -10.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6299",
    fill: "#ffc828",
    d: "M16.476 25.223a11.163 11.163 0 0 0 1.823-2.4c1.456 1.535 1.014 2.492 1.534 2.739.5.235.853.713 1.908-.048.275 1.545-.66 1.86.093 3.026.222.344 1.327.344 1.327.344a4.872 4.872 0 0 1-4.5 2.512c-1.3 0-3.671-.718-4.19-2.159a1.429 1.429 0 0 0 1.441-.517c.452-.765-.519-2.345.564-3.497z",
    "data-name": "Path 6299",
    transform: "translate(-3.355 -10.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6300",
    fill: "#ffc929",
    d: "M16.552 25.495a12.006 12.006 0 0 0 1.785-2.337c1.444 1.51 1.037 2.442 1.523 2.678s.824.74 1.9-.009c.238 1.521-.651 1.745.081 2.923.215.346 1.325.358 1.325.358a4.828 4.828 0 0 1-4.459 2.457c-1.283 0-3.629-.7-4.139-2.106A1.415 1.415 0 0 0 16 28.934c.446-.764-.523-2.306.552-3.439z",
    "data-name": "Path 6300",
    transform: "translate(-3.406 -10.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6301",
    fill: "#ffc92a",
    d: "M16.578 25.55a12.026 12.026 0 0 0 1.778-2.327c1.438 1.505 1.03 2.435 1.517 2.672s.822.733 1.893-.011c.237 1.514-.649 1.738.081 2.911.215.345 1.32.358 1.32.358a4.81 4.81 0 0 1-4.44 2.444c-1.277 0-3.616-.7-4.123-2.1a1.409 1.409 0 0 0 1.425-.523c.444-.759-.521-2.295.549-3.424z",
    "data-name": "Path 6301",
    transform: "translate(-3.424 -10.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6302",
    fill: "#ffca2c",
    d: "M16.6 25.6a11.986 11.986 0 0 0 1.77-2.317c1.432 1.5 1.023 2.429 1.511 2.666s.82.726 1.886-.014c.236 1.506-.647 1.73.08 2.9.215.345 1.315.359 1.315.359a4.79 4.79 0 0 1-4.421 2.432c-1.273 0-3.6-.7-4.108-2.089a1.4 1.4 0 0 0 1.42-.521c.447-.757-.515-2.287.547-3.416z",
    "data-name": "Path 6302",
    transform: "translate(-3.441 -10.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6303",
    fill: "#ffca2d",
    d: "M16.629 25.657a11.986 11.986 0 0 0 1.762-2.306c1.427 1.5 1.015 2.422 1.505 2.659s.819.719 1.878-.016c.235 1.5-.645 1.722.08 2.886.216.345 1.311.359 1.311.359a4.769 4.769 0 0 1-4.4 2.419c-1.267 0-3.589-.7-4.092-2.081a1.4 1.4 0 0 0 1.414-.52c.439-.757-.517-2.279.542-3.4z",
    "data-name": "Path 6303",
    transform: "translate(-3.459 -10.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6304",
    fill: "#ffca2e",
    d: "M16.654 25.712a11.946 11.946 0 0 0 1.754-2.3c1.421 1.49 1.008 2.416 1.5 2.653s.817.713 1.871-.019c.234 1.492-.643 1.715.079 2.873.216.345 1.306.36 1.306.36a4.75 4.75 0 0 1-4.383 2.407c-1.263 0-3.576-.694-4.077-2.073a1.394 1.394 0 0 0 1.409-.518c.438-.749-.513-2.266.541-3.383z",
    "data-name": "Path 6304",
    transform: "translate(-3.476 -10.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6305",
    fill: "#ffcb2f",
    d: "M16.679 25.766a11.968 11.968 0 0 0 1.746-2.286c1.415 1.485 1 2.409 1.493 2.646.477.231.815.706 1.864-.022.234 1.484-.64 1.707.078 2.861.216.345 1.3.36 1.3.36a4.73 4.73 0 0 1-4.36 2.395c-1.257 0-3.562-.691-4.062-2.065a1.388 1.388 0 0 0 1.4-.516c.439-.749-.507-2.261.541-3.373z",
    "data-name": "Path 6305",
    transform: "translate(-3.493 -10.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6306",
    fill: "#ffcb31",
    d: "M16.7 25.82a11.929 11.929 0 0 0 1.738-2.276c1.409 1.481.993 2.4 1.487 2.64.475.23.813.7 1.856-.025.233 1.477-.638 1.7.078 2.848.217.345 1.3.361 1.3.361a4.71 4.71 0 0 1-4.344 2.382c-1.252 0-3.549-.689-4.046-2.057a1.384 1.384 0 0 0 1.4-.514c.431-.745-.507-2.25.531-3.359z",
    "data-name": "Path 6306",
    transform: "translate(-3.511 -10.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6307",
    fill: "#ffcb32",
    d: "M16.73 25.875a11.921 11.921 0 0 0 1.73-2.266c1.4 1.476.987 2.4 1.482 2.633.473.228.811.692 1.849-.027.232 1.47-.637 1.692.078 2.836.217.345 1.292.361 1.292.361a4.691 4.691 0 0 1-4.325 2.369c-1.247 0-3.536-.687-4.031-2.048a1.379 1.379 0 0 0 1.392-.512c.432-.743-.504-2.242.533-3.346z",
    "data-name": "Path 6307",
    transform: "translate(-3.528 -10.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6308",
    fill: "#fc3",
    d: "M16.755 25.929a11.912 11.912 0 0 0 1.722-2.256c1.4 1.471.979 2.389 1.475 2.627a1.338 1.338 0 0 0 1.842-.03c.231 1.463-.635 1.684.077 2.823.217.345 1.288.362 1.288.362a4.671 4.671 0 0 1-4.306 2.357c-1.242 0-3.522-.684-4.015-2.041a1.374 1.374 0 0 0 1.387-.51c.431-.74-.501-2.232.53-3.332z",
    "data-name": "Path 6308",
    transform: "translate(-3.545 -10.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6309",
    fill: "#ffcc35",
    d: "M16.782 25.983a11.9 11.9 0 0 0 1.718-2.246c1.392 1.466.972 2.382 1.47 2.621a1.336 1.336 0 0 0 1.835-.032c.23 1.456-.633 1.676.077 2.811.217.345 1.283.362 1.283.362a4.65 4.65 0 0 1-4.287 2.345c-1.237 0-3.509-.681-4-2.032a1.367 1.367 0 0 0 1.381-.509c.424-.738-.503-2.224.523-3.32z",
    "data-name": "Path 6309",
    transform: "translate(-3.564 -10.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6310",
    fill: "#ffcc36",
    d: "M16.806 26.037a11.875 11.875 0 0 0 1.706-2.237c1.386 1.461.965 2.376 1.464 2.614a1.333 1.333 0 0 0 1.824-.034c.229 1.448-.63 1.669.076 2.8.218.345 1.278.363 1.278.363a4.63 4.63 0 0 1-4.268 2.332c-1.232 0-3.5-.678-3.984-2.024a1.362 1.362 0 0 0 1.375-.507c.431-.735-.491-2.216.529-3.307z",
    "data-name": "Path 6310",
    transform: "translate(-3.58 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6311",
    fill: "#ffcd37",
    d: "M16.831 26.092a11.886 11.886 0 0 0 1.7-2.225c1.38 1.457.958 2.369 1.458 2.608a1.331 1.331 0 0 0 1.82-.038c.229 1.441-.628 1.661.075 2.786.218.345 1.274.363 1.274.363a4.612 4.612 0 0 1-4.249 2.32c-1.227 0-3.482-.676-3.969-2.016a1.358 1.358 0 0 0 1.37-.505c.424-.731-.493-2.206.521-3.293z",
    "data-name": "Path 6311",
    transform: "translate(-3.597 -10.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6312",
    fill: "#ffcd39",
    d: "M16.857 26.146a11.88 11.88 0 0 0 1.69-2.215c1.374 1.452.95 2.362 1.452 2.6a1.328 1.328 0 0 0 1.813-.04c.228 1.433-.629 1.655.075 2.773.217.346 1.269.364 1.269.364a4.591 4.591 0 0 1-4.23 2.307c-1.222 0-3.469-.673-3.954-2.008a1.352 1.352 0 0 0 1.364-.5c.425-.727-.488-2.198.521-3.281z",
    "data-name": "Path 6312",
    transform: "translate(-3.615 -10.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6313",
    fill: "#ffcd3a",
    d: "M16.882 26.2a11.874 11.874 0 0 0 1.682-2.2c1.368 1.447.943 2.356 1.446 2.595a1.325 1.325 0 0 0 1.805-.043c.227 1.426-.627 1.647.074 2.76.218.346 1.264.364 1.264.364a4.572 4.572 0 0 1-4.211 2.3c-1.217 0-3.455-.671-3.938-2a1.348 1.348 0 0 0 1.359-.5c.424-.735-.484-2.197.519-3.276z",
    "data-name": "Path 6313",
    transform: "translate(-3.632 -10.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6314",
    fill: "#ffce3b",
    d: "M16.909 26.255a11.9 11.9 0 0 0 1.675-2.195c1.363 1.442.936 2.349 1.44 2.589a1.322 1.322 0 0 0 1.8-.045c.226 1.419-.625 1.64.074 2.748.218.346 1.26.365 1.26.365A4.552 4.552 0 0 1 18.964 32c-1.211 0-3.442-.668-3.923-1.992a1.341 1.341 0 0 0 1.353-.5c.42-.723-.483-2.179.515-3.253z",
    "data-name": "Path 6314",
    transform: "translate(-3.651 -10.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6315",
    fill: "#ffce3c",
    d: "M16.933 26.309a11.863 11.863 0 0 0 1.667-2.185c1.356 1.437.929 2.343 1.434 2.582a1.32 1.32 0 0 0 1.791-.048c.225 1.412-.623 1.632.073 2.735.218.346 1.255.365 1.255.365a4.532 4.532 0 0 1-4.173 2.27c-1.207 0-3.428-.665-3.907-1.983a1.337 1.337 0 0 0 1.348-.5c.418-.716-.48-2.166.512-3.236z",
    "data-name": "Path 6315",
    transform: "translate(-3.667 -10.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6316",
    fill: "#ffce3e",
    d: "M16.959 26.362a11.891 11.891 0 0 0 1.659-2.174c1.351 1.432.922 2.336 1.428 2.576a1.317 1.317 0 0 0 1.784-.051c.224 1.4-.621 1.625.073 2.723.218.346 1.25.365 1.25.365A4.512 4.512 0 0 1 19 32.06c-1.2 0-3.415-.663-3.892-1.975a1.332 1.332 0 0 0 1.342-.5c.416-.712-.478-2.156.509-3.223z",
    "data-name": "Path 6316",
    transform: "translate(-3.685 -10.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6317",
    fill: "#ffcf3f",
    d: "M16.984 26.417a11.83 11.83 0 0 0 1.651-2.164c1.345 1.428.914 2.329 1.422 2.569a1.315 1.315 0 0 0 1.776-.053c.223 1.4-.62 1.617.072 2.71.219.346 1.246.366 1.246.366a4.492 4.492 0 0 1-4.135 2.245c-1.2 0-3.4-.66-3.877-1.967a1.327 1.327 0 0 0 1.337-.494c.416-.712-.476-2.15.508-3.212z",
    "data-name": "Path 6317",
    transform: "translate(-3.702 -10.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6318",
    fill: "#ffcf40",
    d: "M17.009 26.471a11.883 11.883 0 0 0 1.643-2.154c1.339 1.423.907 2.323 1.416 2.563a1.312 1.312 0 0 0 1.769-.056c.223 1.39-.618 1.61.071 2.7.219.346 1.241.366 1.241.366a4.473 4.473 0 0 1-4.115 2.233c-1.191 0-3.388-.658-3.861-1.959a1.321 1.321 0 0 0 1.331-.492c.414-.711-.47-2.143.505-3.201z",
    "data-name": "Path 6318",
    transform: "translate(-3.719 -10.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6319",
    fill: "#ffcf42",
    d: "M17.034 26.525a11.821 11.821 0 0 0 1.635-2.144c1.333 1.418.9 2.316 1.41 2.557a1.31 1.31 0 0 0 1.761-.058c.222 1.382-.616 1.6.071 2.685.219.346 1.237.367 1.237.367a4.452 4.452 0 0 1-4.1 2.221c-1.186 0-3.375-.655-3.846-1.951a1.315 1.315 0 0 0 1.326-.491c.416-.711-.463-2.132.506-3.186z",
    "data-name": "Path 6319",
    transform: "translate(-3.736 -11.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6320",
    fill: "#ffd043",
    d: "M17.061 26.579a11.852 11.852 0 0 0 1.627-2.134c1.328 1.413.892 2.309 1.4 2.55a1.307 1.307 0 0 0 1.754-.061c.221 1.375-.614 1.594.07 2.673.219.346 1.232.367 1.232.367a4.434 4.434 0 0 1-4.077 2.208c-1.181 0-3.361-.652-3.83-1.943a1.311 1.311 0 0 0 1.32-.489c.414-.702-.457-2.121.504-3.171z",
    "data-name": "Path 6320",
    transform: "translate(-3.754 -11.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6321",
    fill: "#ffd044",
    d: "M17.085 26.634A11.814 11.814 0 0 0 18.7 24.51c1.322 1.408.885 2.3 1.4 2.544a1.3 1.3 0 0 0 1.747-.064c.22 1.368-.612 1.587.07 2.66.22.346 1.227.368 1.227.368a4.414 4.414 0 0 1-4.058 2.2c-1.176 0-3.348-.65-3.815-1.935a1.3 1.3 0 0 0 1.314-.487c.415-.704-.459-2.117.5-3.162z",
    "data-name": "Path 6321",
    transform: "translate(-3.771 -11.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6322",
    fill: "#ffd045",
    d: "M17.11 26.688a11.829 11.829 0 0 0 1.611-2.114c1.316 1.4.878 2.3 1.393 2.538a1.3 1.3 0 0 0 1.74-.066c.22 1.361-.61 1.579.069 2.648.22.346 1.223.368 1.223.368a4.394 4.394 0 0 1-4.039 2.184c-1.171 0-3.334-.647-3.8-1.927a1.3 1.3 0 0 0 1.309-.485c.406-.698-.459-2.105.494-3.146z",
    "data-name": "Path 6322",
    transform: "translate(-3.788 -11.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6323",
    fill: "#ffd147",
    d: "M17.137 26.742a11.83 11.83 0 0 0 1.6-2.1c1.31 1.4.871 2.29 1.387 2.531a1.3 1.3 0 0 0 1.732-.069c.219 1.354-.608 1.572.068 2.635.22.346 1.218.368 1.218.368a4.374 4.374 0 0 1-4.02 2.171c-1.166 0-3.321-.645-3.784-1.918a1.3 1.3 0 0 0 1.3-.483c.411-.697-.449-2.098.499-3.135z",
    "data-name": "Path 6323",
    transform: "translate(-3.806 -11.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6324",
    fill: "#ffd148",
    d: "M17.161 26.8a11.822 11.822 0 0 0 1.6-2.093c1.3 1.394.863 2.283 1.38 2.525a1.3 1.3 0 0 0 1.725-.072c.218 1.346-.606 1.564.068 2.623.22.346 1.213.369 1.213.369a4.354 4.354 0 0 1-4 2.159c-1.161 0-3.308-.642-3.769-1.91a1.29 1.29 0 0 0 1.3-.482c.397-.695-.458-2.089.483-3.119z",
    "data-name": "Path 6324",
    transform: "translate(-3.823 -11.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6325",
    fill: "#ffd149",
    d: "M17.186 26.851a11.827 11.827 0 0 0 1.587-2.083c1.3 1.389.856 2.277 1.375 2.518a1.3 1.3 0 0 0 1.718-.074c.217 1.339-.6 1.557.067 2.61.221.346 1.209.369 1.209.369a4.335 4.335 0 0 1-3.982 2.146c-1.156 0-3.294-.639-3.753-1.9a1.284 1.284 0 0 0 1.292-.48c.401-.689-.449-2.077.487-3.106z",
    "data-name": "Path 6325",
    transform: "translate(-3.84 -11.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6326",
    fill: "#ffd14b",
    d: "M17.213 26.9a11.82 11.82 0 0 0 1.579-2.073c1.292 1.384.849 2.27 1.369 2.512a1.293 1.293 0 0 0 1.71-.077c.216 1.332-.6 1.549.067 2.6.221.346 1.2.37 1.2.37a4.315 4.315 0 0 1-3.963 2.134c-1.151 0-3.281-.637-3.738-1.894A1.279 1.279 0 0 0 16.729 30c.399-.689-.447-2.07.484-3.1z",
    "data-name": "Path 6326",
    transform: "translate(-3.859 -11.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6327",
    fill: "#ffd24c",
    d: "M17.237 26.959a11.8 11.8 0 0 0 1.571-2.059c1.287 1.38.842 2.263 1.363 2.505a1.29 1.29 0 0 0 1.7-.079c.215 1.324-.6 1.541.066 2.585.221.346 1.2.37 1.2.37A4.3 4.3 0 0 1 19.2 32.4c-1.146 0-3.268-.634-3.723-1.886a1.274 1.274 0 0 0 1.281-.476c.395-.683-.446-2.059.479-3.079z",
    "data-name": "Path 6327",
    transform: "translate(-3.875 -11.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6328",
    fill: "#ffd24d",
    d: "M17.263 27.014a11.82 11.82 0 0 0 1.563-2.053c1.281 1.375.834 2.256 1.357 2.5a1.288 1.288 0 0 0 1.7-.082c.214 1.317-.6 1.534.065 2.573.221.346 1.2.371 1.2.371a4.275 4.275 0 0 1-3.925 2.109c-1.141 0-3.254-.632-3.707-1.877a1.27 1.27 0 0 0 1.276-.474c.388-.681-.449-2.051.471-3.067z",
    "data-name": "Path 6328",
    transform: "translate(-3.893 -11.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6329",
    fill: "#ffd24e",
    d: "M17.289 27.068a11.8 11.8 0 0 0 1.555-2.043c1.275 1.37.827 2.25 1.351 2.493a1.286 1.286 0 0 0 1.689-.085c.214 1.31-.6 1.526.065 2.56.221.346 1.19.371 1.19.371a4.255 4.255 0 0 1-3.906 2.1c-1.135 0-3.241-.629-3.692-1.869a1.264 1.264 0 0 0 1.27-.472c.395-.68-.436-2.044.478-3.055z",
    "data-name": "Path 6329",
    transform: "translate(-3.91 -11.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6330",
    fill: "#ffd350",
    d: "M17.314 27.121a11.823 11.823 0 0 0 1.548-2.032c1.269 1.365.82 2.243 1.345 2.487a1.284 1.284 0 0 0 1.681-.087c.213 1.3-.595 1.519.065 2.548.221.346 1.185.372 1.185.372a4.236 4.236 0 0 1-3.887 2.084c-1.131 0-3.228-.626-3.676-1.861a1.258 1.258 0 0 0 1.264-.47c.393-.675-.434-2.033.475-3.041z",
    "data-name": "Path 6330",
    transform: "translate(-3.928 -11.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6331",
    fill: "#ffd351",
    d: "M17.34 27.176a11.78 11.78 0 0 0 1.539-2.022c1.263 1.36.813 2.237 1.339 2.48a1.282 1.282 0 0 0 1.674-.09c.212 1.3-.593 1.511.064 2.535.221.346 1.181.372 1.181.372a4.217 4.217 0 0 1-3.867 2.072c-1.125 0-3.214-.624-3.661-1.853a1.253 1.253 0 0 0 1.259-.469c.391-.67-.432-2.021.472-3.025z",
    "data-name": "Path 6331",
    transform: "translate(-3.945 -11.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6332",
    fill: "#ffd352",
    d: "M17.365 27.23a11.828 11.828 0 0 0 1.535-2.012c1.257 1.355.806 2.23 1.333 2.474A1.279 1.279 0 0 0 21.9 27.6c.211 1.288-.591 1.5.064 2.523.222.346 1.176.373 1.176.373a4.2 4.2 0 0 1-3.849 2.059c-1.12 0-3.2-.621-3.645-1.845a1.248 1.248 0 0 0 1.253-.467c.385-.668-.432-2.014.466-3.013z",
    "data-name": "Path 6332",
    transform: "translate(-3.962 -11.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6333",
    fill: "#ffd454",
    d: "M17.39 27.284a11.824 11.824 0 0 0 1.524-2c1.251 1.35.8 2.224 1.328 2.467a1.277 1.277 0 0 0 1.659-.1c.21 1.281-.589 1.5.063 2.51.222.345 1.172.373 1.172.373a4.177 4.177 0 0 1-3.829 2.047c-1.115 0-3.187-.619-3.63-1.837a1.243 1.243 0 0 0 1.248-.465c.386-.661-.425-2 .465-2.995z",
    "data-name": "Path 6333",
    transform: "translate(-3.98 -11.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6334",
    fill: "#ffd455",
    d: "M17.415 27.339a11.809 11.809 0 0 0 1.516-1.992c1.246 1.345.791 2.217 1.321 2.46a1.275 1.275 0 0 0 1.652-.1c.209 1.274-.587 1.488.062 2.5.222.345 1.167.374 1.167.374a4.157 4.157 0 0 1-3.81 2.034c-1.11 0-3.174-.616-3.615-1.829a1.238 1.238 0 0 0 1.242-.463c.386-.661-.421-1.994.465-2.984z",
    "data-name": "Path 6334",
    transform: "translate(-3.997 -11.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6335",
    fill: "#ffd456",
    d: "M17.441 27.393a11.813 11.813 0 0 0 1.508-1.982c1.24 1.341.783 2.21 1.315 2.454a1.273 1.273 0 0 0 1.645-.1c.208 1.266-.586 1.481.062 2.485.222.345 1.162.374 1.162.374a4.138 4.138 0 0 1-3.791 2.022c-1.105 0-3.161-.613-3.6-1.821a1.232 1.232 0 0 0 1.237-.461c.384-.658-.419-1.985.462-2.971z",
    "data-name": "Path 6335",
    transform: "translate(-4.015 -11.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6336",
    fill: "#ffd558",
    d: "M17.466 27.447a11.822 11.822 0 0 0 1.5-1.971c1.234 1.336.776 2.2 1.31 2.448a1.27 1.27 0 0 0 1.638-.1c.208 1.259-.584 1.473.061 2.473.223.345 1.158.375 1.158.375a4.118 4.118 0 0 1-3.772 2.01c-1.1 0-3.147-.611-3.584-1.812a1.227 1.227 0 0 0 1.231-.459c.381-.661-.417-1.981.458-2.964z",
    "data-name": "Path 6336",
    transform: "translate(-4.032 -11.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6337",
    fill: "#ffd559",
    d: "M17.492 27.5a11.848 11.848 0 0 0 1.492-1.961c1.228 1.331.769 2.2 1.3 2.442a1.268 1.268 0 0 0 1.63-.105c.207 1.251-.582 1.466.061 2.46.223.345 1.153.375 1.153.375a4.1 4.1 0 0 1-3.753 2c-1.095 0-3.134-.608-3.568-1.8a1.223 1.223 0 0 0 1.225-.458c.383-.659-.41-1.973.46-2.953z",
    "data-name": "Path 6337",
    transform: "translate(-4.049 -11.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6338",
    fill: "#ffd55a",
    d: "M17.517 27.556A11.806 11.806 0 0 0 19 25.605c1.223 1.326.762 2.19 1.3 2.435a1.266 1.266 0 0 0 1.623-.108c.206 1.244-.58 1.458.06 2.448.223.345 1.148.376 1.148.376a4.078 4.078 0 0 1-3.731 1.983c-1.09 0-3.12-.606-3.553-1.8a1.217 1.217 0 0 0 1.22-.456c.375-.645-.414-1.953.45-2.927z",
    "data-name": "Path 6338",
    transform: "translate(-4.067 -11.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6339",
    fill: "#ffd65b",
    d: "M17.542 27.61a11.863 11.863 0 0 0 1.476-1.941c1.217 1.321.755 2.184 1.292 2.429a1.264 1.264 0 0 0 1.615-.111c.205 1.237-.578 1.45.059 2.435.223.345 1.144.376 1.144.376a4.059 4.059 0 0 1-3.715 1.973c-1.085 0-3.107-.6-3.538-1.788a1.212 1.212 0 0 0 1.214-.454c.378-.647-.406-1.949.453-2.919z",
    "data-name": "Path 6339",
    transform: "translate(-4.084 -11.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6340",
    fill: "#ffd65d",
    d: "M17.568 27.664a11.822 11.822 0 0 0 1.468-1.931c1.211 1.316.747 2.177 1.286 2.422a1.262 1.262 0 0 0 1.608-.114c.2 1.23-.575 1.443.059 2.422.224.345 1.139.377 1.139.377a4.04 4.04 0 0 1-3.7 1.96c-1.08 0-3.094-.6-3.522-1.78a1.206 1.206 0 0 0 1.209-.452c.379-.643-.4-1.938.453-2.904z",
    "data-name": "Path 6340",
    transform: "translate(-4.101 -11.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6341",
    fill: "#ffd65e",
    d: "M17.594 27.719a11.881 11.881 0 0 0 1.46-1.921c1.2 1.312.74 2.171 1.28 2.416a1.26 1.26 0 0 0 1.6-.116c.2 1.223-.573 1.435.058 2.41.224.345 1.134.377 1.134.377a4.02 4.02 0 0 1-3.677 1.948c-1.075 0-3.08-.6-3.507-1.771a1.2 1.2 0 0 0 1.2-.45c.378-.642-.396-1.932.452-2.893z",
    "data-name": "Path 6341",
    transform: "translate(-4.119 -11.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6342",
    fill: "#ffd75f",
    d: "M17.618 27.773a11.84 11.84 0 0 0 1.452-1.911c1.2 1.307.733 2.164 1.274 2.409a1.258 1.258 0 0 0 1.594-.119c.2 1.215-.572 1.428.058 2.4.224.345 1.13.377 1.13.377a4 4 0 0 1-3.658 1.935c-1.069 0-3.067-.6-3.491-1.763a1.2 1.2 0 0 0 1.2-.449c.369-.638-.401-1.922.441-2.879z",
    "data-name": "Path 6342",
    transform: "translate(-4.136 -11.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6343",
    fill: "#ffd761",
    d: "M17.645 27.827a11.873 11.873 0 0 0 1.445-1.9c1.193 1.3.726 2.158 1.268 2.4a1.257 1.257 0 0 0 1.587-.121c.2 1.208-.57 1.42.057 2.385.224.345 1.125.378 1.125.378a3.98 3.98 0 0 1-3.639 1.923c-1.065 0-3.053-.593-3.476-1.755a1.19 1.19 0 0 0 1.192-.447c.369-.633-.396-1.91.441-2.863z",
    "data-name": "Path 6343",
    transform: "translate(-4.154 -11.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6344",
    fill: "#ffd762",
    d: "M17.67 27.881a11.863 11.863 0 0 0 1.436-1.89c1.187 1.3.718 2.151 1.262 2.4a1.254 1.254 0 0 0 1.579-.124c.2 1.2-.568 1.412.057 2.372.225.345 1.12.378 1.12.378a3.96 3.96 0 0 1-3.624 1.909c-1.059 0-3.04-.59-3.461-1.747a1.186 1.186 0 0 0 1.186-.445c.375-.634-.387-1.904.445-2.853z",
    "data-name": "Path 6344",
    transform: "translate(-4.171 -11.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6345",
    fill: "#ffd863",
    d: "M17.694 27.935a11.866 11.866 0 0 0 1.429-1.88c1.182 1.292.711 2.145 1.256 2.39a1.252 1.252 0 0 0 1.572-.127c.2 1.193-.566 1.4.056 2.36.225.345 1.116.379 1.116.379a3.942 3.942 0 0 1-3.6 1.9c-1.055 0-3.027-.587-3.445-1.739a1.181 1.181 0 0 0 1.181-.443c.366-.63-.39-1.895.435-2.84z",
    "data-name": "Path 6345",
    transform: "translate(-4.188 -11.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6346",
    fill: "#ffd864",
    d: "M17.72 27.989a11.889 11.889 0 0 0 1.42-1.87c1.176 1.288.7 2.138 1.25 2.384a1.251 1.251 0 0 0 1.564-.129c.2 1.186-.564 1.4.055 2.347.225.345 1.111.379 1.111.379a3.922 3.922 0 0 1-3.581 1.886c-1.049 0-3.013-.585-3.43-1.731a1.176 1.176 0 0 0 1.175-.441c.367-.625-.384-1.884.436-2.825z",
    "data-name": "Path 6346",
    transform: "translate(-4.205 -11.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6347",
    fill: "#ffd866",
    d: "M17.746 28.043a11.894 11.894 0 0 0 1.413-1.86c1.17 1.283.7 2.131 1.244 2.378a1.249 1.249 0 0 0 1.557-.132c.2 1.179-.562 1.39.055 2.334.225.345 1.107.38 1.107.38a3.9 3.9 0 0 1-3.562 1.873c-1.044 0-3-.582-3.414-1.723a1.169 1.169 0 0 0 1.17-.44c.361-.621-.385-1.873.43-2.81z",
    "data-name": "Path 6347",
    transform: "translate(-4.223 -11.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6348",
    fill: "#ffd967",
    d: "M17.771 28.1a11.919 11.919 0 0 0 1.4-1.85c1.164 1.278.689 2.125 1.238 2.371a1.248 1.248 0 0 0 1.55-.134c.2 1.172-.56 1.382.054 2.322.226.345 1.1.38 1.1.38a3.883 3.883 0 0 1-3.543 1.861c-1.039 0-2.986-.58-3.4-1.715a1.165 1.165 0 0 0 1.164-.438c.366-.62-.372-1.867.437-2.797z",
    "data-name": "Path 6348",
    transform: "translate(-4.24 -11.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6349",
    fill: "#ffd968",
    d: "M17.8 28.152a11.952 11.952 0 0 0 1.4-1.839c1.158 1.273.682 2.118 1.233 2.365a1.246 1.246 0 0 0 1.543-.137c.2 1.164-.558 1.374.054 2.309.226.345 1.1.38 1.1.38a3.863 3.863 0 0 1-3.53 1.849c-1.034 0-2.973-.577-3.384-1.706a1.16 1.16 0 0 0 1.159-.436c.355-.616-.381-1.857.425-2.785z",
    "data-name": "Path 6349",
    transform: "translate(-4.258 -12.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6350",
    fill: "#ffd96a",
    d: "M17.821 28.206a11.924 11.924 0 0 0 1.389-1.829c1.152 1.268.675 2.111 1.226 2.358a1.244 1.244 0 0 0 1.535-.14c.2 1.157-.556 1.367.053 2.3.226.345 1.093.381 1.093.381a3.843 3.843 0 0 1-3.505 1.836c-1.029 0-2.959-.574-3.368-1.7a1.154 1.154 0 0 0 1.153-.434c.358-.614-.373-1.848.424-2.772z",
    "data-name": "Path 6350",
    transform: "translate(-4.274 -12.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6351",
    fill: "#ffda6b",
    d: "M17.847 28.261a11.99 11.99 0 0 0 1.381-1.819c1.146 1.263.667 2.105 1.221 2.352a1.243 1.243 0 0 0 1.528-.143c.2 1.15-.554 1.359.052 2.284.226.345 1.088.381 1.088.381a3.824 3.824 0 0 1-3.486 1.823c-1.024 0-2.946-.572-3.353-1.69a1.15 1.15 0 0 0 1.147-.432c.357-.608-.37-1.837.422-2.756z",
    "data-name": "Path 6351",
    transform: "translate(-4.292 -12.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6352",
    fill: "#ffda6c",
    d: "M17.873 28.315a11.975 11.975 0 0 0 1.373-1.809c1.141 1.259.66 2.1 1.215 2.345a1.241 1.241 0 0 0 1.521-.145c.195 1.142-.552 1.352.052 2.272.227.345 1.083.382 1.083.382a3.8 3.8 0 0 1-3.467 1.811c-1.019 0-2.933-.569-3.337-1.682a1.143 1.143 0 0 0 1.142-.43c.354-.607-.369-1.829.418-2.744z",
    "data-name": "Path 6352",
    transform: "translate(-4.31 -12.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6353",
    fill: "#ffda6d",
    d: "M17.9 28.369a12.032 12.032 0 0 0 1.365-1.8c1.135 1.254.653 2.092 1.209 2.339a1.24 1.24 0 0 0 1.513-.147c.194 1.135-.55 1.344.052 2.259.227.345 1.079.382 1.079.382a3.785 3.785 0 0 1-3.448 1.8c-1.014 0-2.919-.567-3.322-1.674a1.139 1.139 0 0 0 1.136-.429c.35-.599-.367-1.819.416-2.73z",
    "data-name": "Path 6353",
    transform: "translate(-4.327 -12.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6354",
    fill: "#ffdb6f",
    d: "M17.924 28.424a12.019 12.019 0 0 0 1.357-1.789c1.129 1.249.646 2.085 1.2 2.333a1.239 1.239 0 0 0 1.506-.15c.193 1.128-.548 1.336.051 2.247.227.345 1.074.383 1.074.383a3.765 3.765 0 0 1-3.429 1.786c-1.009 0-2.906-.564-3.307-1.666a1.133 1.133 0 0 0 1.131-.427c.354-.601-.359-1.811.417-2.717z",
    "data-name": "Path 6354",
    transform: "translate(-4.345 -12.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6355",
    fill: "#ffdb70",
    d: "M17.949 28.478A12.08 12.08 0 0 0 19.3 26.7c1.123 1.244.638 2.079 1.2 2.326a1.237 1.237 0 0 0 1.5-.153c.192 1.12-.546 1.328.051 2.234.227.345 1.069.383 1.069.383a3.746 3.746 0 0 1-3.41 1.774c-1 0-2.892-.561-3.291-1.657a1.129 1.129 0 0 0 1.125-.425c.343-.598-.365-1.801.405-2.704z",
    "data-name": "Path 6355",
    transform: "translate(-4.362 -12.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6356",
    fill: "#ffdb71",
    d: "M17.975 28.532a12.068 12.068 0 0 0 1.341-1.769c1.118 1.239.631 2.072 1.191 2.32A1.236 1.236 0 0 0 22 28.927c.191 1.113-.544 1.321.05 2.222.228.345 1.065.384 1.065.384a3.726 3.726 0 0 1-3.391 1.761c-1 0-2.879-.559-3.276-1.649a1.122 1.122 0 0 0 1.12-.423c.345-.594-.358-1.792.407-2.69z",
    "data-name": "Path 6356",
    transform: "translate(-4.38 -12.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6357",
    fill: "#ffdc73",
    d: "M18 28.585a12.1 12.1 0 0 0 1.333-1.758c1.111 1.235.624 2.066 1.185 2.314A1.234 1.234 0 0 0 22 28.983c.19 1.106-.542 1.313.049 2.209.228.345 1.06.384 1.06.384a3.706 3.706 0 0 1-3.372 1.749c-.993 0-2.866-.556-3.26-1.641a1.118 1.118 0 0 0 1.114-.421c.347-.592-.351-1.783.409-2.678z",
    "data-name": "Path 6357",
    transform: "translate(-4.396 -12.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6358",
    fill: "#ffdc74",
    d: "M18.025 28.64a12.123 12.123 0 0 0 1.326-1.748c1.106 1.23.616 2.059 1.179 2.307a1.233 1.233 0 0 0 1.477-.161c.19 1.1-.54 1.305.049 2.2.228.345 1.055.385 1.055.385a3.687 3.687 0 0 1-3.353 1.737c-.989 0-2.852-.554-3.245-1.633a1.113 1.113 0 0 0 1.108-.419c.344-.592-.349-1.778.404-2.668z",
    "data-name": "Path 6358",
    transform: "translate(-4.414 -12.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6359",
    fill: "#ffdc75",
    d: "M18.051 28.694a12.117 12.117 0 0 0 1.317-1.738c1.1 1.224.609 2.053 1.173 2.3a1.232 1.232 0 0 0 1.47-.163c.189 1.092-.538 1.3.048 2.184.228.345 1.051.385 1.051.385a3.668 3.668 0 0 1-3.333 1.724c-.983 0-2.839-.551-3.229-1.625a1.108 1.108 0 0 0 1.1-.417c.344-.585-.348-1.764.403-2.65z",
    "data-name": "Path 6359",
    transform: "translate(-4.432 -12.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6360",
    fill: "#fd7",
    d: "M18.076 28.748a12.184 12.184 0 0 0 1.31-1.728c1.094 1.22.6 2.046 1.167 2.294a1.231 1.231 0 0 0 1.462-.166c.188 1.084-.536 1.29.048 2.172.229.345 1.046.386 1.046.386a3.648 3.648 0 0 1-3.315 1.712c-.978 0-2.825-.548-3.214-1.617a1.1 1.1 0 0 0 1.1-.416c.337-.585-.346-1.755.396-2.637z",
    "data-name": "Path 6360",
    transform: "translate(-4.449 -12.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6361",
    fill: "#ffdd78",
    d: "M18.1 28.8a12.213 12.213 0 0 0 1.3-1.718c1.088 1.215.595 2.039 1.161 2.288a1.23 1.23 0 0 0 1.455-.169c.187 1.077-.534 1.283.047 2.159.229.345 1.042.386 1.042.386a3.628 3.628 0 0 1-3.3 1.7c-.973 0-2.812-.546-3.2-1.609a1.1 1.1 0 0 0 1.092-.414c.347-.575-.332-1.742.403-2.623z",
    "data-name": "Path 6361",
    transform: "translate(-4.466 -12.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6362",
    fill: "#ffdd79",
    d: "M18.128 28.857a12.285 12.285 0 0 0 1.294-1.707c1.082 1.21.587 2.033 1.156 2.281a1.229 1.229 0 0 0 1.448-.171c.186 1.069-.532 1.275.046 2.147.229.345 1.037.387 1.037.387a3.609 3.609 0 0 1-3.276 1.687c-.968 0-2.8-.543-3.183-1.6a1.092 1.092 0 0 0 1.086-.412c.335-.578-.336-1.738.392-2.612z",
    "data-name": "Path 6362",
    transform: "translate(-4.484 -12.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6363",
    fill: "#ffde7a",
    d: "M18.151 28.911a12.284 12.284 0 0 0 1.286-1.7c1.077 1.205.58 2.026 1.149 2.275a1.226 1.226 0 0 0 1.44-.174c.185 1.062-.53 1.267.046 2.134.229.345 1.032.387 1.032.387a3.589 3.589 0 0 1-3.257 1.675c-.963 0-2.786-.541-3.168-1.592a1.086 1.086 0 0 0 1.081-.41c.34-.571-.334-1.726.391-2.595z",
    "data-name": "Path 6363",
    transform: "translate(-4.5 -12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6364",
    fill: "#ffde7c",
    d: "M18.177 28.966a12.321 12.321 0 0 0 1.278-1.687c1.071 1.2.573 2.02 1.144 2.269a1.226 1.226 0 0 0 1.433-.176c.184 1.055-.528 1.26.045 2.122.23.345 1.028.388 1.028.388a3.57 3.57 0 0 1-3.238 1.662c-.958 0-2.772-.538-3.152-1.584a1.081 1.081 0 0 0 1.075-.408c.332-.573-.333-1.721.387-2.586z",
    "data-name": "Path 6364",
    transform: "translate(-4.518 -12.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6365",
    fill: "#ffde7d",
    d: "M18.2 29.02a12.3 12.3 0 0 0 1.27-1.677c1.065 1.2.565 2.013 1.138 2.262a1.224 1.224 0 0 0 1.426-.179c.184 1.048-.526 1.252.045 2.109.23.345 1.023.388 1.023.388a3.552 3.552 0 0 1-3.219 1.65c-.953 0-2.759-.535-3.137-1.576a1.076 1.076 0 0 0 1.069-.406c.334-.568-.326-1.71.385-2.571z",
    "data-name": "Path 6365",
    transform: "translate(-4.536 -12.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6366",
    fill: "#ffdf7e",
    d: "M18.228 29.074a12.362 12.362 0 0 0 1.262-1.667c1.059 1.191.558 2.006 1.132 2.256a1.224 1.224 0 0 0 1.419-.182c.183 1.041-.524 1.245.044 2.1.23.345 1.018.389 1.018.389A3.531 3.531 0 0 1 19.9 33.6c-.948 0-2.745-.533-3.122-1.568a1.072 1.072 0 0 0 1.064-.4c.333-.566-.322-1.701.386-2.558z",
    "data-name": "Path 6366",
    transform: "translate(-4.553 -12.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6367",
    fill: "#ffdf80",
    d: "M18.254 29.128a12.389 12.389 0 0 0 1.254-1.657c1.053 1.186.551 2 1.126 2.25a1.223 1.223 0 0 0 1.411-.184c.182 1.033-.522 1.237.044 2.084.231.345 1.014.389 1.014.389a3.512 3.512 0 0 1-3.181 1.625c-.943 0-2.732-.53-3.106-1.56a1.065 1.065 0 0 0 1.058-.4c.326-.565-.324-1.694.38-2.547z",
    "data-name": "Path 6367",
    transform: "translate(-4.571 -12.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6368",
    fill: "#ffdf81",
    d: "M18.28 29.183a12.454 12.454 0 0 0 1.246-1.647c1.047 1.181.544 1.993 1.12 2.243a1.223 1.223 0 0 0 1.4-.187c.181 1.026-.52 1.229.043 2.071.231.345 1.009.39 1.009.39a3.492 3.492 0 0 1-3.162 1.613c-.937 0-2.719-.528-3.091-1.551a1.061 1.061 0 0 0 1.053-.4c.33-.56-.316-1.684.382-2.532z",
    "data-name": "Path 6368",
    transform: "translate(-4.588 -12.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6369",
    fill: "#ffe082",
    d: "M18.3 29.237a12.485 12.485 0 0 0 1.242-1.637c1.042 1.176.536 1.987 1.114 2.237a1.221 1.221 0 0 0 1.4-.189c.181 1.018-.518 1.222.042 2.059.231.345 1 .39 1 .39a3.474 3.474 0 0 1-3.143 1.6c-.933 0-2.705-.525-3.075-1.544a1.056 1.056 0 0 0 1.047-.4c.326-.553-.315-1.672.373-2.516z",
    "data-name": "Path 6369",
    transform: "translate(-4.605 -12.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6370",
    fill: "#ffe083",
    d: "M18.329 29.291a12.556 12.556 0 0 0 1.23-1.627c1.036 1.172.529 1.98 1.108 2.23a1.22 1.22 0 0 0 1.389-.192c.18 1.011-.516 1.214.042 2.046.231.345 1 .391 1 .391a3.454 3.454 0 0 1-3.124 1.588c-.927 0-2.692-.522-3.06-1.536a1.05 1.05 0 0 0 1.042-.4c.323-.549-.313-1.66.373-2.5z",
    "data-name": "Path 6370",
    transform: "translate(-4.622 -12.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6371",
    fill: "#ffe085",
    d: "M18.356 29.345a12.607 12.607 0 0 0 1.223-1.616c1.03 1.167.522 1.974 1.1 2.224a1.221 1.221 0 0 0 1.382-.195c.179 1-.514 1.206.041 2.034.232.345 1 .391 1 .391a3.434 3.434 0 0 1-3.1 1.575c-.923 0-2.678-.52-3.045-1.527a1.045 1.045 0 0 0 1.036-.4c.313-.545-.318-1.65.363-2.486z",
    "data-name": "Path 6371",
    transform: "translate(-4.641 -12.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6372",
    fill: "#ffe186",
    d: "M18.381 29.4a12.667 12.667 0 0 0 1.219-1.607c1.024 1.162.514 1.967 1.1 2.217a1.22 1.22 0 0 0 1.375-.2c.178 1-.512 1.2.041 2.021.232.345.99.392.99.392a3.415 3.415 0 0 1-3.086 1.563c-.917 0-2.665-.517-3.029-1.519a1.04 1.04 0 0 0 1.03-.394c.311-.543-.316-1.642.36-2.473z",
    "data-name": "Path 6372",
    transform: "translate(-4.658 -12.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6373",
    fill: "#ffe187",
    d: "M18.406 29.453a12.676 12.676 0 0 0 1.207-1.6c1.018 1.157.507 1.961 1.09 2.211a1.219 1.219 0 0 0 1.367-.2c.177.99-.51 1.191.04 2.009.232.345.986.392.986.392a3.4 3.4 0 0 1-3.067 1.55c-.912 0-2.652-.515-3.014-1.511a1.034 1.034 0 0 0 1.025-.392c.318-.539-.304-1.632.366-2.459z",
    "data-name": "Path 6373",
    transform: "translate(-4.675 -12.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6374",
    fill: "#ffe189",
    d: "M18.432 29.509a12.833 12.833 0 0 0 1.2-1.586c1.012 1.152.5 1.954 1.084 2.2a1.219 1.219 0 0 0 1.36-.2c.176.982-.508 1.183.039 2 .232.345.981.392.981.392a3.377 3.377 0 0 1-3.047 1.538c-.907 0-2.638-.512-3-1.5a1.03 1.03 0 0 0 1.019-.39c.316-.545-.301-1.631.364-2.454z",
    "data-name": "Path 6374",
    transform: "translate(-4.692 -12.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6375",
    fill: "#ffe18a",
    d: "M18.457 29.562a12.846 12.846 0 0 0 1.191-1.575c1.006 1.147.493 1.948 1.079 2.2a1.219 1.219 0 0 0 1.353-.205c.175.975-.506 1.175.039 1.984.233.345.977.392.977.392a3.357 3.357 0 0 1-3.028 1.526c-.9 0-2.625-.509-2.983-1.495A1.024 1.024 0 0 0 18.1 32c.311-.538-.3-1.619.357-2.438z",
    "data-name": "Path 6375",
    transform: "translate(-4.71 -12.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6376",
    fill: "#ffe28b",
    d: "M18.482 29.616a12.973 12.973 0 0 0 1.183-1.565c1 1.143.485 1.941 1.072 2.192a1.218 1.218 0 0 0 1.345-.208c.175.968-.5 1.168.039 1.971.233.345.972.393.972.393a3.338 3.338 0 0 1-3.009 1.513c-.9 0-2.611-.507-2.968-1.486a1.019 1.019 0 0 0 1.008-.387c.312-.534-.295-1.608.358-2.423z",
    "data-name": "Path 6376",
    transform: "translate(-4.727 -12.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6377",
    fill: "#ffe28c",
    d: "M18.508 29.67a12.99 12.99 0 0 0 1.175-1.555c.995 1.138.478 1.935 1.067 2.186a1.218 1.218 0 0 0 1.338-.21c.174.961-.5 1.16.038 1.959.233.345.967.393.967.393a3.318 3.318 0 0 1-2.99 1.5c-.892 0-2.6-.5-2.952-1.478a1.014 1.014 0 0 0 1-.385c.312-.531-.291-1.599.357-2.41z",
    "data-name": "Path 6377",
    transform: "translate(-4.745 -12.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6378",
    fill: "#ffe28e",
    d: "M18.533 29.725A13.073 13.073 0 0 0 19.7 28.18c.989 1.133.47 1.928 1.061 2.179a1.218 1.218 0 0 0 1.331-.213c.173.953-.5 1.153.038 1.946.234.345.963.394.963.394a3.3 3.3 0 0 1-2.971 1.489c-.887 0-2.585-.5-2.937-1.47a1.009 1.009 0 0 0 1-.383c.304-.529-.295-1.591.348-2.397z",
    "data-name": "Path 6378",
    transform: "translate(-4.761 -13.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6379",
    fill: "#ffe38f",
    d: "M18.559 29.779a13.151 13.151 0 0 0 1.159-1.535c.983 1.128.463 1.922 1.055 2.173A1.218 1.218 0 0 0 22.1 30.2c.172.946-.5 1.145.037 1.934.234.345.958.394.958.394a3.28 3.28 0 0 1-2.952 1.476c-.882 0-2.571-.5-2.921-1.462a1 1 0 0 0 .992-.381c.302-.524-.292-1.58.345-2.382z",
    "data-name": "Path 6379",
    transform: "translate(-4.779 -13.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6380",
    fill: "#ffe390",
    d: "M18.584 29.833a13.142 13.142 0 0 0 1.151-1.525c.977 1.123.456 1.915 1.049 2.166a1.219 1.219 0 0 0 1.316-.218c.171.938-.5 1.137.036 1.921.234.345.953.395.953.395a3.26 3.26 0 0 1-2.933 1.464c-.877 0-2.558-.5-2.906-1.454a1 1 0 0 0 .986-.379c.305-.523-.283-1.572.348-2.37z",
    "data-name": "Path 6380",
    transform: "translate(-4.797 -13.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6381",
    fill: "#ffe392",
    d: "M18.609 29.888a13.327 13.327 0 0 0 1.143-1.515c.972 1.119.449 1.909 1.043 2.16a1.218 1.218 0 0 0 1.309-.221c.17.931-.494 1.13.036 1.909.234.345.949.4.949.4a3.241 3.241 0 0 1-2.914 1.451c-.872 0-2.544-.494-2.89-1.446a.992.992 0 0 0 .98-.378c.303-.523-.281-1.567.344-2.36z",
    "data-name": "Path 6381",
    transform: "translate(-4.814 -13.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6382",
    fill: "#ffe493",
    d: "M18.635 29.942a13.324 13.324 0 0 0 1.135-1.5c.966 1.114.442 1.9 1.037 2.154a1.218 1.218 0 0 0 1.3-.223c.169.924-.492 1.122.035 1.9.234.345.944.4.944.4a3.221 3.221 0 0 1-2.893 1.427c-.867 0-2.531-.491-2.875-1.438a.987.987 0 0 0 .975-.376c.301-.517-.278-1.555.342-2.344z",
    "data-name": "Path 6382",
    transform: "translate(-4.831 -13.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6383",
    fill: "#ffe494",
    d: "M18.66 30a13.526 13.526 0 0 0 1.127-1.5c.96 1.109.434 1.9 1.031 2.147a1.219 1.219 0 0 0 1.294-.226c.169.917-.489 1.114.035 1.884.234.345.939.4.939.4a3.2 3.2 0 0 1-2.876 1.427c-.861 0-2.517-.488-2.86-1.43a.983.983 0 0 0 .969-.374c.301-.516-.274-1.547.341-2.328z",
    "data-name": "Path 6383",
    transform: "translate(-4.848 -13.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6384",
    fill: "#ffe495",
    d: "M18.685 30.05a13.528 13.528 0 0 0 1.115-1.484c.954 1.1.427 1.889 1.025 2.141a1.219 1.219 0 0 0 1.287-.229c.168.91-.487 1.107.034 1.871.235.345.935.4.935.4a3.184 3.184 0 0 1-2.857 1.414c-.857 0-2.5-.486-2.844-1.421a.977.977 0 0 0 .964-.372c.302-.513-.268-1.539.341-2.32z",
    "data-name": "Path 6384",
    transform: "translate(-4.866 -13.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6385",
    fill: "#ffe597",
    d: "M18.711 30.1a13.682 13.682 0 0 0 1.111-1.474c.948 1.1.419 1.883 1.019 2.135a1.219 1.219 0 0 0 1.28-.232c.167.9-.485 1.1.033 1.859.235.345.93.4.93.4a3.164 3.164 0 0 1-2.838 1.4c-.851 0-2.491-.483-2.829-1.413a.971.971 0 0 0 .958-.37c.298-.505-.267-1.524.336-2.305z",
    "data-name": "Path 6385",
    transform: "translate(-4.884 -13.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6386",
    fill: "#ffe598",
    d: "M18.736 30.158a13.754 13.754 0 0 0 1.1-1.464c.942 1.094.412 1.876 1.013 2.128a1.22 1.22 0 0 0 1.273-.234c.166.895-.483 1.091.033 1.846.235.345.925.4.925.4a3.145 3.145 0 0 1-2.819 1.389c-.846 0-2.477-.481-2.813-1.405a.967.967 0 0 0 .953-.368c.299-.506-.263-1.519.335-2.292z",
    "data-name": "Path 6386",
    transform: "translate(-4.9 -13.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6387",
    fill: "#ffe599",
    d: "M18.761 30.213a13.91 13.91 0 0 0 1.1-1.454c.937 1.089.4 1.87 1.007 2.122a1.221 1.221 0 0 0 1.265-.236c.166.887-.481 1.083.032 1.834.236.344.921.4.921.4a3.126 3.126 0 0 1-2.8 1.377c-.841 0-2.464-.478-2.8-1.4a.962.962 0 0 0 .947-.366c.291-.502-.264-1.509.328-2.277z",
    "data-name": "Path 6387",
    transform: "translate(-4.918 -13.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6388",
    fill: "#ffe69b",
    d: "M18.787 30.268a14.161 14.161 0 0 0 1.088-1.444c.931 1.084.4 1.863 1 2.115a1.222 1.222 0 0 0 1.258-.239c.165.88-.479 1.076.032 1.821.236.344.916.4.916.4a3.108 3.108 0 0 1-2.781 1.363c-.836 0-2.45-.475-2.783-1.389a.957.957 0 0 0 .942-.365c.292-.498-.259-1.498.328-2.262z",
    "data-name": "Path 6388",
    transform: "translate(-4.936 -13.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6389",
    fill: "#ffe69c",
    d: "M18.813 30.321a14.179 14.179 0 0 0 1.08-1.433c.925 1.08.39 1.857 1 2.109a1.222 1.222 0 0 0 1.25-.242c.164.873-.477 1.068.031 1.809.236.344.911.4.911.4a3.088 3.088 0 0 1-2.761 1.352c-.831 0-2.437-.473-2.767-1.38a.95.95 0 0 0 .936-.363c.284-.497-.262-1.491.32-2.252z",
    "data-name": "Path 6389",
    transform: "translate(-4.953 -13.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6390",
    fill: "#ffe69d",
    d: "M18.838 30.375a14.455 14.455 0 0 0 1.072-1.423c.919 1.075.383 1.85.989 2.1a1.222 1.222 0 0 0 1.243-.245c.163.866-.475 1.06.031 1.8.236.344.907.4.907.4a3.069 3.069 0 0 1-2.742 1.34c-.826 0-2.424-.47-2.752-1.372a.945.945 0 0 0 .93-.361c.284-.495-.253-1.483.322-2.239z",
    "data-name": "Path 6390",
    transform: "translate(-4.971 -13.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6391",
    fill: "#ffe79f",
    d: "M18.863 30.43a14.484 14.484 0 0 0 1.064-1.413c.913 1.07.376 1.844.984 2.1a1.223 1.223 0 0 0 1.236-.247c.162.859-.473 1.053.03 1.784.237.344.9.4.9.4a3.05 3.05 0 0 1-2.723 1.328c-.821 0-2.41-.468-2.736-1.364a.942.942 0 0 0 .925-.359c.287-.495-.25-1.477.32-2.229z",
    "data-name": "Path 6391",
    transform: "translate(-4.987 -13.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6392",
    fill: "#ffe7a0",
    d: "M18.889 30.484a14.7 14.7 0 0 0 1.056-1.4c.907 1.065.368 1.838.978 2.09a1.224 1.224 0 0 0 1.229-.25c.161.851-.47 1.045.029 1.771a1.417 1.417 0 0 0 .9.4 3.03 3.03 0 0 1-2.7 1.315c-.816 0-2.4-.465-2.721-1.356a.936.936 0 0 0 .919-.357c.277-.49-.255-1.466.31-2.213z",
    "data-name": "Path 6392",
    transform: "translate(-5.005 -13.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6393",
    fill: "#ffe7a1",
    d: "M18.914 30.538a14.763 14.763 0 0 0 1.048-1.393c.9 1.06.361 1.831.972 2.083a1.227 1.227 0 0 0 1.222-.252c.16.844-.469 1.037.029 1.758a1.41 1.41 0 0 0 .893.4 3.013 3.013 0 0 1-2.685 1.3c-.811 0-2.383-.462-2.706-1.348a.932.932 0 0 0 .914-.355c.281-.48-.246-1.45.313-2.193z",
    "data-name": "Path 6393",
    transform: "translate(-5.022 -13.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6394",
    fill: "#ffe8a2",
    d: "M18.94 30.593a15.006 15.006 0 0 0 1.04-1.383c.9 1.055.353 1.825.966 2.077a1.227 1.227 0 0 0 1.214-.255c.16.836-.467 1.029.028 1.746a1.4 1.4 0 0 0 .888.4 2.993 2.993 0 0 1-2.666 1.29c-.806 0-2.37-.46-2.69-1.34a.925.925 0 0 0 .908-.354c.28-.474-.242-1.442.312-2.181z",
    "data-name": "Path 6394",
    transform: "translate(-5.04 -13.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6395",
    fill: "#ffe8a4",
    d: "M18.964 30.647A15.146 15.146 0 0 0 20 29.274c.89 1.051.346 1.818.96 2.07a1.228 1.228 0 0 0 1.207-.258c.159.829-.464 1.022.028 1.733a1.4 1.4 0 0 0 .884.4 2.973 2.973 0 0 1-2.651 1.281c-.8 0-2.357-.457-2.675-1.332a.921.921 0 0 0 .9-.352c.281-.477-.236-1.434.311-2.169z",
    "data-name": "Path 6395",
    transform: "translate(-5.057 -13.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6396",
    fill: "#ffe8a5",
    d: "M18.99 30.7a15.319 15.319 0 0 0 1.024-1.363c.884 1.046.339 1.812.954 2.064.309.127.657.094 1.2-.26.158.822-.462 1.014.027 1.721a1.391 1.391 0 0 0 .879.4 2.955 2.955 0 0 1-2.628 1.265c-.8 0-2.343-.455-2.659-1.324a.915.915 0 0 0 .9-.35c.273-.47-.239-1.421.303-2.153z",
    "data-name": "Path 6396",
    transform: "translate(-5.074 -13.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6397",
    fill: "#ffe9a6",
    d: "M19.016 30.755a15.58 15.58 0 0 0 1.016-1.355c.878 1.041.332 1.806.948 2.057.307.126.655.088 1.192-.263.157.815-.46 1.006.026 1.708a1.384 1.384 0 0 0 .874.4 2.936 2.936 0 0 1-2.609 1.253c-.791 0-2.33-.452-2.644-1.315a.911.911 0 0 0 .892-.348c.275-.466-.232-1.411.305-2.137z",
    "data-name": "Path 6397",
    transform: "translate(-5.092 -13.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6398",
    fill: "#ffe9a8",
    d: "M19.04 30.809a15.782 15.782 0 0 0 1.008-1.342c.872 1.036.324 1.8.942 2.051.305.125.653.081 1.185-.265.156.807-.458 1 .026 1.7a1.377 1.377 0 0 0 .87.4 2.917 2.917 0 0 1-2.59 1.24c-.785 0-2.317-.449-2.629-1.307a.9.9 0 0 0 .886-.347c.274-.468-.229-1.407.302-2.13z",
    "data-name": "Path 6398",
    transform: "translate(-5.109 -13.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6399",
    fill: "#ffe9a9",
    d: "M19.066 30.863a15.969 15.969 0 0 0 1-1.332c.867 1.031.317 1.793.936 2.045.3.124.651.074 1.178-.268.156.8-.456.991.026 1.683a1.375 1.375 0 0 0 .865.4 2.9 2.9 0 0 1-2.571 1.232c-.781 0-2.3-.447-2.613-1.3a.9.9 0 0 0 .881-.345c.271-.464-.227-1.396.298-2.115z",
    "data-name": "Path 6399",
    transform: "translate(-5.126 -13.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6400",
    fill: "#ffeaaa",
    d: "M19.093 30.918a16.406 16.406 0 0 0 .992-1.322c.86 1.027.31 1.786.93 2.038.3.122.65.067 1.171-.271.155.793-.454.983.025 1.67a1.366 1.366 0 0 0 .86.4 2.879 2.879 0 0 1-2.552 1.216c-.775 0-2.29-.444-2.6-1.291a.9.9 0 0 0 .875-.343c.272-.457-.221-1.383.299-2.097z",
    "data-name": "Path 6400",
    transform: "translate(-5.144 -13.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6401",
    fill: "#ffeaab",
    d: "M19.116 30.973c.363-.5.862-1.047.984-1.312.855 1.022.3 1.78.924 2.032.3.121.648.061 1.163-.273.154.786-.452.976.025 1.658a1.36 1.36 0 0 0 .856.4 2.86 2.86 0 0 1-2.533 1.2c-.77 0-2.277-.442-2.582-1.283a.889.889 0 0 0 .869-.341c.269-.454-.222-1.372.294-2.081z",
    "data-name": "Path 6401",
    transform: "translate(-5.161 -13.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6402",
    fill: "#ffeaad",
    d: "M19.142 31.027c.359-.495.852-1.036.976-1.3.849 1.017.295 1.773.918 2.026.3.12.647.054 1.156-.276.153.779-.45.968.024 1.645a1.355 1.355 0 0 0 .851.4 2.842 2.842 0 0 1-2.513 1.191c-.765 0-2.263-.439-2.567-1.275a.884.884 0 0 0 .864-.339c.266-.453-.218-1.367.291-2.072z",
    "data-name": "Path 6402",
    transform: "translate(-5.178 -13.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6403",
    fill: "#ffebae",
    d: "M19.167 31.08c.355-.491.843-1.025.968-1.291.843 1.012.287 1.767.912 2.019.3.119.645.047 1.148-.278.152.771-.447.96.023 1.633a1.348 1.348 0 0 0 .846.405 2.823 2.823 0 0 1-2.495 1.178c-.76 0-2.25-.436-2.552-1.266a.879.879 0 0 0 .858-.338c.268-.452-.211-1.36.292-2.062z",
    "data-name": "Path 6403",
    transform: "translate(-5.195 -13.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6404",
    fill: "#ffebaf",
    d: "M19.193 31.134c.351-.488.833-1.013.961-1.281.837 1.007.28 1.76.907 2.013.294.118.643.04 1.141-.281.151.764-.445.952.023 1.62a1.343 1.343 0 0 0 .842.406 2.8 2.8 0 0 1-2.475 1.166c-.755 0-2.236-.434-2.536-1.258a.874.874 0 0 0 .853-.336c.261-.449-.209-1.351.284-2.049z",
    "data-name": "Path 6404",
    transform: "translate(-5.213 -13.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6405",
    fill: "#ffebb1",
    d: "M19.219 31.189c.347-.485.824-1 .952-1.271.832 1 .273 1.754.9 2.006.292.117.641.034 1.134-.284.151.756-.443.945.022 1.608a1.337 1.337 0 0 0 .837.406 2.785 2.785 0 0 1-2.456 1.154c-.75 0-2.223-.431-2.521-1.25a.868.868 0 0 0 .847-.334c.266-.446-.207-1.342.285-2.035z",
    "data-name": "Path 6405",
    transform: "translate(-5.231 -13.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6406",
    fill: "#ffecb2",
    d: "M19.244 31.243c.343-.482.815-.99.945-1.261.826 1 .265 1.748.895 2 .29.116.639.027 1.127-.286.15.749-.441.937.022 1.6a1.331 1.331 0 0 0 .833.407 2.766 2.766 0 0 1-2.437 1.141c-.745 0-2.21-.429-2.505-1.242a.863.863 0 0 0 .842-.332c.256-.449-.208-1.338.278-2.027z",
    "data-name": "Path 6406",
    transform: "translate(-5.248 -13.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6407",
    fill: "#ffecb3",
    d: "M19.27 31.3c.339-.479.806-.979.937-1.251.82.993.258 1.742.889 1.993.288.115.638.02 1.119-.289.149.742-.439.929.021 1.583a1.326 1.326 0 0 0 .828.407 2.749 2.749 0 0 1-2.418 1.129c-.74 0-2.2-.426-2.49-1.234a.858.858 0 0 0 .836-.33c.257-.443-.203-1.326.278-2.008z",
    "data-name": "Path 6407",
    transform: "translate(-5.266 -13.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6408",
    fill: "#ffecb4",
    d: "M19.3 31.352c.335-.475.8-.968.929-1.241.814.988.251 1.735.883 1.987.286.114.636.013 1.112-.292.148.735-.437.922.02 1.57a1.323 1.323 0 0 0 .823.408 2.729 2.729 0 0 1-2.4 1.116c-.735 0-2.183-.423-2.474-1.226a.854.854 0 0 0 .831-.328c.251-.436-.205-1.314.276-1.994z",
    "data-name": "Path 6408",
    transform: "translate(-5.283 -14.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6409",
    fill: "#ffedb6",
    d: "M19.32 31.406c.331-.472.787-.957.921-1.231.808.983.244 1.729.877 1.981.285.113.634.007 1.1-.294.147.728-.435.914.02 1.558a1.317 1.317 0 0 0 .819.408 2.711 2.711 0 0 1-2.38 1.1c-.729 0-2.169-.421-2.459-1.218a.848.848 0 0 0 .825-.326c.257-.431-.193-1.302.277-1.978z",
    "data-name": "Path 6409",
    transform: "translate(-5.3 -14.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6410",
    fill: "#ffedb7",
    d: "M19.346 31.46c.327-.469.778-.945.913-1.221.8.978.236 1.722.871 1.974.283.112.633 0 1.1-.3.146.72-.432.906.019 1.545a1.312 1.312 0 0 0 .814.409 2.692 2.692 0 0 1-2.363 1.095c-.725 0-2.156-.418-2.444-1.21a.841.841 0 0 0 .819-.325c.252-.427-.194-1.295.271-1.967z",
    "data-name": "Path 6410",
    transform: "translate(-5.318 -14.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6411",
    fill: "#ffedb8",
    d: "M19.371 31.515c.323-.466.768-.934.905-1.211.8.974.229 1.716.865 1.968.281.111.631-.007 1.09-.3.145.713-.43.9.019 1.533a1.307 1.307 0 0 0 .809.409 2.673 2.673 0 0 1-2.342 1.079c-.719 0-2.142-.416-2.428-1.2a.837.837 0 0 0 .814-.323c.251-.429-.19-1.288.268-1.955z",
    "data-name": "Path 6411",
    transform: "translate(-5.335 -14.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6412",
    fill: "#ffeeba",
    d: "M19.4 31.569c.319-.463.759-.923.9-1.2.791.969.221 1.709.859 1.962.279.11.629-.013 1.083-.3.145.705-.428.89.018 1.52a1.3 1.3 0 0 0 .8.41 2.655 2.655 0 0 1-2.323 1.067c-.715 0-2.129-.413-2.413-1.193a.832.832 0 0 0 .808-.321c.247-.429-.189-1.282.268-1.945z",
    "data-name": "Path 6412",
    transform: "translate(-5.352 -14.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6413",
    fill: "#feb",
    d: "M19.422 31.623c.314-.46.75-.911.889-1.19.785.964.214 1.7.853 1.955.277.109.627-.02 1.075-.3.144.7-.426.883.017 1.508a1.3 1.3 0 0 0 .8.41 2.637 2.637 0 0 1-2.3 1.054c-.709 0-2.116-.41-2.4-1.185a.827.827 0 0 0 .8-.319c.249-.427-.182-1.274.266-1.933z",
    "data-name": "Path 6413",
    transform: "translate(-5.37 -14.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6414",
    fill: "#ffeebc",
    d: "M19.447 31.677c.311-.456.74-.9.881-1.18.779.959.207 1.7.847 1.949.275.108.625-.027 1.068-.307.143.691-.424.875.017 1.5a1.292 1.292 0 0 0 .8.411 2.619 2.619 0 0 1-2.285 1.042c-.7 0-2.1-.408-2.382-1.177a.822.822 0 0 0 .8-.317c.238-.425-.193-1.266.254-1.921z",
    "data-name": "Path 6414",
    transform: "translate(-5.387 -14.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6415",
    fill: "#ffefbe",
    d: "M19.473 31.732c.306-.454.731-.889.873-1.17.773.954.2 1.691.841 1.942.273.107.624-.034 1.061-.31.142.684-.422.867.016 1.483a1.288 1.288 0 0 0 .791.411 2.6 2.6 0 0 1-2.265 1.029c-.7 0-2.089-.4-2.367-1.169a.817.817 0 0 0 .792-.315c.243-.416-.179-1.25.258-1.901z",
    "data-name": "Path 6415",
    transform: "translate(-5.404 -14.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6416",
    fill: "#ffefbf",
    d: "M19.5 31.785c.3-.45.721-.877.865-1.159.768.949.192 1.684.835 1.936.271.106.622-.04 1.054-.312.142.677-.419.859.016 1.47a1.284 1.284 0 0 0 .786.412 2.581 2.581 0 0 1-2.247 1.017c-.694 0-2.075-.4-2.351-1.16a.812.812 0 0 0 .786-.313c.24-.416-.177-1.244.256-1.891z",
    "data-name": "Path 6416",
    transform: "translate(-5.421 -14.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6417",
    fill: "#ffefc0",
    d: "M19.524 31.839c.3-.447.712-.866.858-1.149.761.944.184 1.678.83 1.929.269.1.62-.047 1.046-.315.141.669-.417.852.015 1.458a1.28 1.28 0 0 0 .781.412 2.564 2.564 0 0 1-2.227 1c-.689 0-2.062-.4-2.336-1.152a.806.806 0 0 0 .781-.312c.238-.41-.172-1.228.252-1.871z",
    "data-name": "Path 6417",
    transform: "translate(-5.44 -14.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6418",
    fill: "#fff0c1",
    d: "M19.55 31.894c.294-.444.7-.855.849-1.139.755.939.177 1.672.824 1.923.267.1.619-.053 1.039-.318.14.662-.415.844.015 1.445a1.274 1.274 0 0 0 .777.413 2.545 2.545 0 0 1-2.208.992c-.684 0-2.049-.4-2.32-1.145a.8.8 0 0 0 .775-.31c.236-.407-.172-1.222.249-1.861z",
    "data-name": "Path 6418",
    transform: "translate(-5.457 -14.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6419",
    fill: "#fff0c3",
    d: "M19.574 31.948c.29-.441.693-.844.842-1.129.75.935.17 1.665.818 1.917.265.1.617-.06 1.032-.321.139.655-.413.836.014 1.432a1.27 1.27 0 0 0 .772.413 2.527 2.527 0 0 1-2.189.98c-.679 0-2.035-.395-2.3-1.136a.8.8 0 0 0 .769-.308c.23-.404-.173-1.214.242-1.848z",
    "data-name": "Path 6419",
    transform: "translate(-5.474 -14.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6420",
    fill: "#fff0c4",
    d: "M19.6 32c.286-.438.684-.832.833-1.119.744.93.162 1.659.812 1.911.263.1.615-.067 1.024-.323.138.647-.411.829.013 1.42a1.266 1.266 0 0 0 .768.414 2.508 2.508 0 0 1-2.17.967c-.674 0-2.022-.392-2.29-1.128a.791.791 0 0 0 .764-.306c.234-.4-.164-1.204.246-1.836z",
    "data-name": "Path 6420",
    transform: "translate(-5.491 -14.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6421",
    fill: "#fff0c5",
    d: "M19.626 32.057c.282-.435.675-.82.826-1.109.738.925.155 1.653.806 1.9.261.1.613-.074 1.017-.326.137.64-.409.821.013 1.407a1.261 1.261 0 0 0 .763.414 2.49 2.49 0 0 1-2.151.957c-.669 0-2.008-.39-2.274-1.12a.786.786 0 0 0 .758-.3c.231-.4-.162-1.198.242-1.823z",
    "data-name": "Path 6421",
    transform: "translate(-5.509 -14.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6422",
    fill: "#fff1c7",
    d: "M19.65 32.111c.278-.431.665-.809.818-1.1.732.92.148 1.646.8 1.9.26.1.612-.08 1.01-.328.136.633-.406.813.013 1.395a1.26 1.26 0 0 0 .758.415 2.473 2.473 0 0 1-2.132.943c-.664 0-1.995-.387-2.259-1.112a.78.78 0 0 0 .753-.3c.23-.4-.159-1.192.239-1.813z",
    "data-name": "Path 6422",
    transform: "translate(-5.526 -14.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6423",
    fill: "#fff1c8",
    d: "M19.676 32.165c.274-.428.656-.8.81-1.089.727.915.14 1.64.794 1.891.258.1.61-.087 1-.331.136.625-.4.805.012 1.382a1.256 1.256 0 0 0 .754.415 2.454 2.454 0 0 1-2.113.93c-.659 0-1.982-.384-2.243-1.1a.774.774 0 0 0 .747-.3c.231-.396-.153-1.181.239-1.798z",
    "data-name": "Path 6423",
    transform: "translate(-5.544 -14.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6424",
    fill: "#fff1c9",
    d: "M19.7 32.219c.27-.425.647-.787.8-1.079.721.911.133 1.634.788 1.885.256.1.608-.094 1-.334.135.618-.4.8.012 1.37a1.253 1.253 0 0 0 .749.416 2.436 2.436 0 0 1-2.094.918c-.653 0-1.968-.382-2.228-1.1a.77.77 0 0 0 .742-.3c.225-.384-.154-1.163.231-1.776z",
    "data-name": "Path 6424",
    transform: "translate(-5.561 -14.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6425",
    fill: "#fff2ca",
    d: "M19.726 32.274c.266-.422.637-.775.794-1.068.715.906.126 1.627.782 1.878.254.1.607-.1.988-.336.134.611-.4.79.011 1.357a1.248 1.248 0 0 0 .744.416 2.418 2.418 0 0 1-2.075.905c-.649 0-1.955-.379-2.213-1.087a.765.765 0 0 0 .736-.3c.227-.383-.148-1.156.233-1.765z",
    "data-name": "Path 6425",
    transform: "translate(-5.578 -14.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6426",
    fill: "#fff2cc",
    d: "M19.752 32.328c.262-.419.628-.764.786-1.058.709.9.118 1.621.776 1.872.252.1.6-.107.98-.339.133.6-.4.782.01 1.345a1.243 1.243 0 0 0 .74.416 2.4 2.4 0 0 1-2.056.893c-.643 0-1.941-.377-2.2-1.079a.76.76 0 0 0 .73-.3c.227-.378-.142-1.145.234-1.75z",
    "data-name": "Path 6426",
    transform: "translate(-5.595 -14.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6427",
    fill: "#fff2cd",
    d: "M19.778 32.382c.258-.416.619-.753.778-1.048.7.9.111 1.615.77 1.866.25.095.6-.114.973-.341.132.6-.4.774.01 1.332a1.243 1.243 0 0 0 .735.417 2.383 2.383 0 0 1-2.037.881c-.638 0-1.928-.374-2.182-1.071a.754.754 0 0 0 .725-.294c.222-.381-.142-1.141.228-1.742z",
    "data-name": "Path 6427",
    transform: "translate(-5.613 -14.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6428",
    fill: "#fff3ce",
    d: "M19.8 32.437c.254-.413.609-.742.77-1.038.7.891.1 1.609.764 1.859.248.094.6-.121.966-.344.131.589-.393.767.009 1.32a1.239 1.239 0 0 0 .73.417 2.365 2.365 0 0 1-2.018.868c-.633 0-1.915-.371-2.166-1.063a.75.75 0 0 0 .719-.292c.226-.377-.136-1.131.226-1.727z",
    "data-name": "Path 6428",
    transform: "translate(-5.63 -14.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6429",
    fill: "#fff3d0",
    d: "M19.828 32.491c.249-.409.6-.73.762-1.028.691.886.1 1.6.758 1.853.247.093.6-.128.959-.347.13.582-.391.758.009 1.307a1.235 1.235 0 0 0 .726.417 2.347 2.347 0 0 1-2 .856c-.628 0-1.9-.369-2.151-1.055a.745.745 0 0 0 .714-.29c.219-.373-.136-1.121.223-1.713z",
    "data-name": "Path 6429",
    transform: "translate(-5.647 -14.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6430",
    fill: "#fff3d1",
    d: "M19.854 32.544c.246-.406.59-.719.755-1.017.686.882.089 1.6.753 1.847.245.092.6-.134.951-.349.13.574-.389.751.008 1.295a1.233 1.233 0 0 0 .721.418 2.33 2.33 0 0 1-1.979.844c-.623 0-1.888-.366-2.135-1.047a.739.739 0 0 0 .708-.288c.215-.372-.136-1.114.218-1.703z",
    "data-name": "Path 6430",
    transform: "translate(-5.666 -14.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6431",
    fill: "#fff4d2",
    d: "M19.879 32.6c.241-.4.581-.707.746-1.007.68.877.081 1.59.747 1.84.243.091.6-.141.944-.352.129.567-.387.743.007 1.282a1.23 1.23 0 0 0 .716.418 2.313 2.313 0 0 1-1.961.831c-.618 0-1.875-.364-2.12-1.039a.733.733 0 0 0 .7-.286c.219-.368-.127-1.104.221-1.687z",
    "data-name": "Path 6431",
    transform: "translate(-5.682 -14.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6432",
    fill: "#fff4d3",
    d: "M19.9 32.653c.237-.4.572-.7.739-1 .674.872.074 1.584.741 1.834.241.09.594-.148.937-.354.128.56-.385.735.007 1.27a1.23 1.23 0 0 0 .712.419 2.3 2.3 0 0 1-1.941.819c-.613 0-1.861-.361-2.1-1.03a.728.728 0 0 0 .7-.285c.205-.364-.133-1.093.205-1.673z",
    "data-name": "Path 6432",
    transform: "translate(-5.699 -14.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6433",
    fill: "#fff4d5",
    d: "M19.93 32.707c.234-.4.562-.685.73-.987.668.867.066 1.578.735 1.827.239.089.593-.155.929-.357.127.553-.382.728.006 1.257a1.227 1.227 0 0 0 .707.419 2.278 2.278 0 0 1-1.922.806c-.608 0-1.848-.358-2.089-1.022a.724.724 0 0 0 .691-.283c.212-.361-.124-1.085.213-1.66z",
    "data-name": "Path 6433",
    transform: "translate(-5.717 -14.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6434",
    fill: "#fff5d6",
    d: "M19.955 32.761c.229-.394.553-.674.723-.977.662.862.059 1.572.729 1.821.237.088.591-.161.922-.36.127.546-.38.72.006 1.245a1.224 1.224 0 0 0 .7.42 2.26 2.26 0 0 1-1.9.794c-.6 0-1.835-.356-2.074-1.014a.718.718 0 0 0 .686-.281c.209-.359-.123-1.076.208-1.648z",
    "data-name": "Path 6434",
    transform: "translate(-5.735 -14.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6435",
    fill: "#fff5d7",
    d: "M19.981 32.816c.225-.39.544-.662.715-.967.656.858.052 1.565.723 1.814.235.087.589-.168.915-.363.126.538-.378.712.005 1.232a1.223 1.223 0 0 0 .7.42 2.243 2.243 0 0 1-1.884.781c-.6 0-1.821-.353-2.058-1.006a.714.714 0 0 0 .68-.279c.205-.354-.122-1.065.204-1.632z",
    "data-name": "Path 6435",
    transform: "translate(-5.752 -14.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6436",
    fill: "#fff5d9",
    d: "M20.007 32.87c.221-.388.534-.651.707-.957.651.853.044 1.559.717 1.808.233.086.587-.175.908-.365.125.531-.376.7 0 1.22a1.224 1.224 0 0 0 .693.421 2.226 2.226 0 0 1-1.865.769c-.593 0-1.808-.351-2.043-1a.707.707 0 0 0 .675-.277c.209-.351-.112-1.056.208-1.619z",
    "data-name": "Path 6436",
    transform: "translate(-5.77 -14.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6437",
    fill: "#fff6da",
    d: "M20.031 32.924c.217-.384.525-.639.7-.947.645.848.037 1.553.711 1.8.231.085.586-.182.9-.368.124.523-.374.7 0 1.207a1.222 1.222 0 0 0 .689.421 2.21 2.21 0 0 1-1.846.756c-.587 0-1.794-.348-2.028-.989a.7.7 0 0 0 .669-.275c.207-.348-.109-1.046.205-1.605z",
    "data-name": "Path 6437",
    transform: "translate(-5.786 -14.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6438",
    fill: "#fff6db",
    d: "M20.057 32.979c.213-.381.516-.628.691-.936.639.843.029 1.547.7 1.8.229.084.584-.188.893-.37.123.516-.371.689 0 1.195a1.219 1.219 0 0 0 .684.422 2.192 2.192 0 0 1-1.827.744c-.583 0-1.781-.345-2.012-.981a.7.7 0 0 0 .664-.273c.21-.354-.102-1.047.207-1.601z",
    "data-name": "Path 6438",
    transform: "translate(-5.804 -15.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6439",
    fill: "#fff6dd",
    d: "M20.082 33.033c.209-.378.506-.617.683-.926.633.838.022 1.541.7 1.789.227.083.582-.2.885-.373.122.509-.368.68 0 1.182a1.224 1.224 0 0 0 .679.422 2.175 2.175 0 0 1-1.808.732c-.577 0-1.767-.343-2-.973a.694.694 0 0 0 .658-.272c.207-.344-.101-1.031.203-1.581z",
    "data-name": "Path 6439",
    transform: "translate(-5.821 -15.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6440",
    fill: "#fff7de",
    d: "M20.107 33.087c.2-.375.5-.606.675-.916.627.833.014 1.535.693 1.783.225.082.58-.2.878-.376.121.5-.366.672 0 1.17a1.221 1.221 0 0 0 .675.423 2.158 2.158 0 0 1-1.789.719c-.573 0-1.754-.34-1.981-.965a.688.688 0 0 0 .652-.27c.202-.341-.1-1.022.197-1.568z",
    "data-name": "Path 6440",
    transform: "translate(-5.839 -15.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6441",
    fill: "#fff7df",
    d: "M20.133 33.142c.2-.372.488-.594.667-.906.622.829.006 1.53.687 1.776.223.082.579-.208.871-.378.121.495-.364.664 0 1.157a1.221 1.221 0 0 0 .67.423 2.143 2.143 0 0 1-1.77.707c-.567 0-1.741-.338-1.966-.957a.682.682 0 0 0 .647-.268c.2-.338-.098-1.013.194-1.554z",
    "data-name": "Path 6441",
    transform: "translate(-5.856 -15.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6442",
    fill: "#fff7e0",
    d: "M20.159 33.2c.2-.368.478-.583.659-.9.615.824 0 1.523.681 1.77.221.08.577-.215.864-.381.12.487-.362.657 0 1.145a1.222 1.222 0 0 0 .665.424 2.127 2.127 0 0 1-1.751.694c-.562 0-1.727-.335-1.951-.949a.678.678 0 0 0 .641-.266c.198-.337-.095-1.004.192-1.537z",
    "data-name": "Path 6442",
    transform: "translate(-5.873 -15.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6443",
    fill: "#fff8e2",
    d: "M20.183 33.249c.193-.365.469-.572.651-.885.61.819-.008 1.517.676 1.763.22.079.575-.221.857-.383.119.48-.36.65 0 1.132a1.221 1.221 0 0 0 .661.424 2.11 2.11 0 0 1-1.731.682c-.557 0-1.714-.332-1.935-.941a.672.672 0 0 0 .638-.264c.191-.332-.1-.994.183-1.528z",
    "data-name": "Path 6443",
    transform: "translate(-5.891 -15.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6444",
    fill: "#fff8e3",
    d: "M20.21 33.3c.189-.362.459-.56.643-.875.6.814-.015 1.51.67 1.757.218.078.573-.228.849-.386.118.473-.358.642 0 1.12a1.22 1.22 0 0 0 .656.425 2.094 2.094 0 0 1-1.713.67c-.552 0-1.7-.33-1.92-.933a.667.667 0 0 0 .63-.262c.193-.327-.091-.983.185-1.516z",
    "data-name": "Path 6444",
    transform: "translate(-5.909 -15.203)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.857ec647b65bae102944c7a9d1226e12.svg";
export { ForwardRef as ReactComponent };